import { defineComponent as K, useSlots as nt, computed as z, openBlock as u, createElementBlock as g, normalizeClass as j, createCommentVNode as H, createBlock as J, unref as Z, renderSlot as ue, createElementVNode as c, toDisplayString as P, createVNode as k, withModifiers as de, createTextVNode as ie, Fragment as te, renderList as oe, normalizeStyle as Me, ref as x, watch as re, nextTick as ce, withCtx as N, watchEffect as st, onMounted as Ne, Teleport as je, Transition as We, provide as Ke, h as ge, inject as Ge, onScopeDispose as ot, toRaw as Te, toRef as Pe } from "vue";
import { _ as ee, a as pe, d as Ye, F as we, b as Ve, c as Ce } from "./Checkbox.vue_vue_type_script_setup_true_lang-DfApYxlV.js";
const rt = ["disabled"], ut = ["src"], ye = /* @__PURE__ */ K({
  __name: "Button",
  props: {
    variant: { default: "stroke" },
    size: { default: "md" },
    icon: {},
    loading: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(t) {
    const l = t, e = nt(), n = z(() => l.variant === "stroke" ? new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAGxlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAACQAAAAAQAAAJAAAAABAAKgAgAEAAAAAQAAACCgAwAEAAAAAQAAACAAAAAAxqyL9QAAAAlwSFlzAAAWJQAAFiUBSVIk8AAABGxJREFUWAm1l11PY1UUhns++gkdpdAB0fFigoERgjZckLmCH+At/4f4Q/whXpsQTTAKAYFhZtAwSWMbB2qBftBzfN7t2fXQVqyl7GR3f5y91vuud++9zqmTGL64pVJput1ufxSG4RPHcXKdTifneZ5Lv0G/SVu7vb19d3x8XMZtMIxr578WLSwspCcmJhZw/AkAScBdFbWqzLn4cHrmOxB7g93POzs7N/dhePc8dFdWVp4D8AXOp8DUWhFmyjGt7Qucvq165rPkaaPReDE3N+f/TmEupPaVgQosLy+ncLBK/VDOo+hMlFHfKuCxxj63c12FQLPKVFKp1Le7u7vXvQz6FFhdXZ3AaQmgSTwlaE206luHPI8rYLYgmjMq0DetbMUGu0m28LNCofCuWq3e2RI97BZFzmCFqjbkYIU4M1V9LbRj9WPFEkqAp6hNjcCtcnlU+GptbS0Xs0vEFXBnZ2c/B2hCpAEy0eNMTmWjaDSvE34aBMFhsVg8yOVyv9Rqtbc4rwqYom2TX3NA6WtrZCsiGfx/vLGxcXR4ePh3QPKswoF7RvNMi2mtdA5Arq4ahtVMJvNq0D7K3pbFxUVFus74eQQOtrk1ViWR/GF/f39HNppMIEuSPSoB5omAJQGwkY/5twcHB79p7bCF7fwSoJdU4xM7owStCNzC6Zu9vb0ro+319fU8BBJEGfDAVBYFjKXp6/8LLpLY/ISv76WCBWdstoJxivmXWqeHDpIVBBiBCtiQQIEKLM+1cJSC7Y/YvcEv2P8kL+ZcVNVh99z19fW8JKcoxRkSEZEOh+vXUYDjNr7vf6dxTAmTL8BKc+U/9aanp4tEnIWRFoVEbW4AJP44OTmpxJ2N0i+Xy42ZmZlZbJ8CqkDNljDWAW+JjbJePHLmgw4L3o8COMgG/68ErPioloDYFH0i9qLD1s3VLHJubm760uYg50POlQUeXxup8cTn9PsKOf5Q/dPT03bv3APGdQAVebcoSOoHPvN94EjTVaNr8YAOV7KF+deDXIhVSyRs1Y6oTyLxBxmMe84nCbWTyaQBA7j7wgFILyQxf9Ti5/P5Jp9ZaaFY6dWiRJap+qOi49zlBVMXoGQHNICMrZnNzc1H3wbv/Py8w2s1z1U0iUjboCoy9Xrdq1Qqdz4gxq2IDqH2XdfEfHgIWLXVaul2pHo/IMZNwCQHomzNz8/rQyRsNpshaaGrAmT8dDodXFxc3I4bXP5scuhMTk7WFDUvD6OAVOB2BFdXVyEHNRspYdePjYv5IIm8OUtLSwUIKDmFFlwtr2udh0BKcFbaJBap0ZfARmEVjyg8Ojp6D0gnDo4S4eXlZQgvkQpRxEUNbd2d3D4KuGziBDQOkPuCrdA/G92EOxUlDBEtpIwlXfdFcXZ2FvBHpsU3vEeOcBS9gFEmZD7MZrPh1NRUyDoReDCJXgVMaPwE/MH8E/CG9l1KiIR9OM723kzHK7kJWIsXU5LW0zlAlUchMmxQ7tbWlre9vS3l/k29YX2ZdX8B/4+Cst1+y+EAAAAASUVORK5CYII=", import.meta.url).href : new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAADN0lEQVRYCb2WS2sUQRRGM1HjK2LUgGgSEFRcuBBBECSCihv9AQFR0JU7V/of3AmCK8FFVpI/IIIvBBe6U/EFghJBBd+Kb6PjOcPcprrTQxK7xwtnbnV11b1fPbqmGj2ztGazOZ+mm2ArDMMqGATrP7Z5jr8FdxqNxhR+RmvM1ILEy2izD7bDUjDhvLa3XHz23U+4CuMIeYfvaB0FtEe8h567YTEUE0Xyog9x+l8wAQpR1DQrFUDyfloegnWQBiwmW8D7qEvLaR/LD+AEIt7ic9abe+KB5KtxR2EI/pTQpE608DEQvRg3UMAWOE/sjfic5QTQwDUeA2egU3LrUxE8ZknLkptDEWvhLDncuJmFckduowMwAtHJOolptv4+3INJ+ADaSvALGYVdsAhckuirj5h3KR+MPZEK2MELsWE0TgU8ov5C2TpSnxkDcemOwV4I4akAY58hzil8a+oc/RLKR2AhhIBUxDU63ODdrI2Yh2l8HGImQoRxv8MoMV/7oG0Dyx4ewW/KcmmuyenTQ59x3GlIZyFm1LNFcT29KDXxejCxCUOA/iGBbuL/yeh7jo5XIESEV8gYuftMvgb0xeQ/qLsOVe0kAfxqInn4Aep2mngEiskd/WNG4BlfyYjh13IZ0oMqROxXgOuRTrtlj9AnUJddJJACUhEuw2aV9IEzoMVnqX/Tqqnn5zZhTK6lOYZDgKNOzUZf04qK5Zf0DwERyhwjCigmt0Gc8ZYrG/vgM0HMNc2s/AL+B4TFOe+hVCYu2tXi3YQKiK/AzRe4ObtuCvgEjjRFEV65um4KeAUxA6mI5ZxU/qt11RTwHjz1ykQMdTU7wXvZoV4w/EwUUBTRzyzkLhC0qdWcAe0ZeGlMBYSgQUSssFE3rCWAWXDTvQD3QCSO/eDzgDMBHp+1WhyLXkosbwA3nssSQvQhRqGekK09g/DKB1YsgRcIgz2N4PhUgIICDy//P0pPNurnZJkAeyHCkU6C+yESxmzoFRm+8uiJ1bqI6DNDhNOriG+QioiyiWtJTpzsr9Fyztp7wuPYC6vJY4PGfphCrMtUybJN2CkKQlwmRbjmOSH/RUAqDDGKUHRrGeoQ8BdfJBsNaB/5WQAAAABJRU5ErkJggg==", import.meta.url).href), o = z(() => !e.default && !!l.icon), a = {
      primary: "bg-green-900 text-white hover:brightness-125",
      stroke: "bg-white border border-gray-200 text-gray-800 hover:border-gray-300"
    }, v = {
      primary: "bg-gray-500/45 text-white/70 pointer-events-none",
      stroke: "bg-white border border-gray-200/55 text-gray-500/40 pointer-events-none"
    }, w = {
      md: "h-[30px] px-2 py-[3px] text-[14px] rounded-[6px] gap-1.5",
      lg: "h-[38px] px-2.5 py-2 text-[16px] rounded-[7px] gap-1.5",
      xl: "h-12 px-[15px] py-[11px] text-[19px] rounded-lg gap-2"
    }, r = {
      md: "!px-2 !py-[5px]",
      lg: "!px-2.5 !py-2",
      xl: "!px-2.5 !py-2"
    }, s = { md: 14, lg: 16, xl: 20 }, p = { md: 18, lg: 20, xl: 20 }, i = {
      md: "size-4",
      lg: "size-[18px]",
      xl: "size-[22px]"
    }, f = z(() => l.size), $ = z(() => ({
      "stroke-gray-800": l.variant === "stroke",
      "stroke-white": l.variant !== "stroke"
    })), V = z(() => i[l.size]), h = z(() => {
      const O = l.disabled || l.loading, R = [
        w[l.size],
        O ? v[l.variant] : a[l.variant]
      ];
      return o.value ? R.push(r[l.size]) : R.push("min-w-[70px]"), R.join(" ");
    });
    return (O, R) => (u(), g("button", {
      class: j(["font-secondary relative inline-flex items-center justify-center font-medium cursor-pointer select-none", h.value]),
      disabled: t.disabled || t.loading
    }, [
      t.loading ? (u(), g("img", {
        key: 0,
        src: n.value,
        class: j(["absolute animate-spin", V.value])
      }, null, 10, ut)) : H("", !0),
      t.icon ? (u(), J(ee, {
        key: 1,
        name: t.icon,
        size: o.value ? p[f.value] : s[f.value],
        class: j([$.value, { invisible: t.loading }])
      }, null, 8, ["name", "size", "class"])) : H("", !0),
      Z(e).default ? (u(), g("span", {
        key: 2,
        class: j({ invisible: t.loading })
      }, [
        ue(O.$slots, "default")
      ], 2)) : H("", !0)
    ], 10, rt));
  }
}), it = ["id", "type", "value", "disabled", "min", "max", "placeholder"], dt = ["for"], ct = {
  key: 0,
  class: "flex items-center gap-1.5 mt-1.5"
}, pt = { class: "font-secondary text-[12px] font-medium text-red-500" }, vt = /* @__PURE__ */ K({
  __name: "Input",
  props: {
    modelValue: {},
    label: {},
    type: {},
    size: { default: "md" },
    disabled: { type: Boolean },
    error: {},
    placeholder: {},
    min: {},
    max: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = (s) => {
      if (e.type !== "number") return;
      const p = s.target, i = parseFloat(p.value);
      isNaN(i) || (e.min != null && i < e.min ? (p.value = String(e.min), n("update:modelValue", p.value)) : e.max != null && i > e.max && (p.value = String(e.max), n("update:modelValue", p.value)));
    }, a = z(
      () => e.label ? e.label.toLowerCase().replace(/\W+/g, " ").trim().replace(/\s/g, "-") : void 0
    ), v = {
      md: "h-[30px] px-[9px] py-[5px] text-[14px] rounded-[6px]",
      lg: "h-[38px] px-[13px] py-[10.5px] text-[14px] rounded-[7px]",
      xl: "h-12 px-[15px] pt-[22px] pb-[6px] text-[14px] rounded-lg"
    }, w = z(() => {
      const s = [v[e.size]];
      return e.disabled ? s.push(
        "bg-gray-900/3 border-gray-200/50 text-gray-800/50! placeholder:text-gray-500/50 pointer-events-none"
      ) : e.error ? s.push(
        "border-red-500 hover:border-red-500 focus:border-red-500 focus:outline-solid focus:outline-2 focus:outline-red-200/50"
      ) : s.push(
        "border-gray-200 hover:border-gray-300 focus:border-green-500 focus:outline-solid focus:outline-2 focus:outline-green-200/50"
      ), e.size === "xl" ? s.push("font-primary") : s.push("font-secondary"), s.join(" ");
    }), r = z(() => {
      const s = [
        "font-primary pointer-events-none absolute text-gray-500 left-4 top-[3px] text-[14px]",
        "origin-[0] transition-all",
        "font-medium scale-75 translate-y-0",
        "peer-placeholder-shown:font-[400] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-[11px]",
        "peer-focus:scale-75 peer-focus:translate-y-0 peer-focus:font-medium"
      ];
      return e.disabled && s.push("text-gray-500/40 peer-placeholder-shown:text-gray-500/50"), s.join(" ");
    });
    return (s, p) => (u(), g("div", null, [
      c("div", {
        class: j(t.size === "xl" ? "relative" : void 0)
      }, [
        c("input", {
          id: a.value,
          type: t.type ?? "text",
          value: t.modelValue,
          disabled: t.disabled,
          min: t.min,
          max: t.max,
          placeholder: t.size === "xl" ? " " : t.placeholder,
          class: j(["peer w-full appearance-none bg-white border text-gray-800 outline-hidden placeholder:text-gray-500", w.value]),
          onInput: p[0] || (p[0] = (i) => s.$emit("update:modelValue", i.target.value)),
          onBlur: o
        }, null, 42, it),
        t.label ? (u(), g("label", {
          key: 0,
          for: a.value,
          class: j(t.size === "xl" ? r.value : "sr-only")
        }, P(t.label), 11, dt)) : H("", !0)
      ], 2),
      t.error ? (u(), g("div", ct, [
        k(ee, {
          name: "Alert",
          size: 12,
          class: "stroke-red-500"
        }),
        c("span", pt, P(t.error), 1)
      ])) : H("", !0)
    ]));
  }
}), $e = /* @__PURE__ */ pe(vt, [["__scopeId", "data-v-beb4dd42"]]), ft = {}, mt = { class: "bg-white border border-black/8 rounded-[10px] container-shadow p-1" };
function gt(t, l) {
  return u(), g("div", mt, [
    ue(t.$slots, "default", {}, void 0, !0)
  ]);
}
const _e = /* @__PURE__ */ pe(ft, [["render", gt], ["__scopeId", "data-v-d3c5919e"]]), He = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], yt = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
function xt(t, l) {
  return new Date(t, l, 0).getDate();
}
function ht(t, l) {
  return new Date(t, l - 1, 1).getDay();
}
const Oe = 1970;
function bt(t) {
  const l = Math.ceil((t - (Oe - 1)) / 12), e = Oe - 1 + l * 12, n = [];
  for (let o = 0; o < 12; o++)
    n.push(e - o);
  return n.reverse();
}
function De(t, l) {
  return t.getFullYear() === l.getFullYear() && t.getMonth() === l.getMonth() && t.getDate() === l.getDate();
}
function At(t, l) {
  const [e, n] = l;
  if (!e || !n) return !1;
  const o = new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime(), a = new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime(), v = new Date(n.getFullYear(), n.getMonth(), n.getDate()).getTime();
  return o > a && o < v;
}
function ne(t) {
  if (!t) return "";
  const l = String(t.getMonth() + 1).padStart(2, "0"), e = String(t.getDate()).padStart(2, "0"), n = t.getFullYear();
  return `${l} / ${e} / ${n}`;
}
function xe(t) {
  const l = t.replace(/\D/g, "");
  if (l.length !== 8) return null;
  const e = parseInt(l.slice(0, 2), 10), n = parseInt(l.slice(2, 4), 10), o = parseInt(l.slice(4, 8), 10);
  if (e < 1 || e > 12 || n < 1 || n > 31 || o < 1) return null;
  const a = new Date(o, e - 1, n);
  return a.getMonth() !== e - 1 || a.getDate() !== n ? null : a;
}
const Dt = { class: "w-[271px] select-none" }, kt = { class: "relative flex items-center justify-center h-8" }, wt = {
  key: 2,
  class: "text-[15px] leading-[32px] font-medium text-gray-800 font-secondary px-2 h-8 flex items-center"
}, Vt = ["onClick", "onMouseenter"], Ct = { class: "relative z-10" }, $t = {
  key: 1,
  class: "grid grid-cols-4 gap-x-1 mt-1"
}, Mt = ["onClick"], St = { class: "relative z-10" }, Rt = {
  key: 2,
  class: "grid grid-cols-4 gap-x-1 mt-1"
}, zt = ["onClick"], Ft = { class: "relative z-10" }, ke = "after:content-[''] after:absolute after:w-[35px] after:h-[34px] after:rounded-[6px]", Se = "before:content-[''] before:absolute before:top-0 before:bottom-0 before:bg-green-200/40 before:z-0", Qe = "after:content-[''] after:absolute after:inset-y-[14px] after:inset-x-0 after:rounded-[6px] after:z-0", It = /* @__PURE__ */ K({
  __name: "Calendar",
  props: {
    year: {},
    month: {},
    selectionMode: {},
    selectedDate: { default: null },
    selectedRange: {},
    hoverDate: { default: null },
    disabled: { type: Boolean, default: !1 },
    showPrevArrow: { type: Boolean, default: !1 },
    showNextArrow: { type: Boolean, default: !1 }
  },
  emits: ["update:year", "update:month", "update:selectionMode", "dateClick", "dateHover"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = z(() => xt(e.year, e.month)), a = z(() => ht(e.year, e.month)), v = z(() => bt(e.year)), w = z(() => e.disabled || e.selectionMode === "month" ? !1 : e.selectionMode === "year" ? !0 : e.showPrevArrow), r = z(() => e.disabled || e.selectionMode === "month" ? !1 : e.selectionMode === "year" ? !0 : e.showNextArrow), s = z(() => {
      if (e.selectionMode === "day")
        return `${He[e.month - 1]} ${e.year}`;
      if (e.selectionMode === "month")
        return `${e.year}`;
      const M = v.value;
      return `${M[0]} - ${M[M.length - 1]}`;
    }), p = () => {
      e.selectionMode === "day" ? n("update:selectionMode", "month") : e.selectionMode === "month" && n("update:selectionMode", "year");
    }, i = () => {
      e.selectionMode === "day" ? e.month === 1 ? (n("update:year", e.year - 1), n("update:month", 12)) : n("update:month", e.month - 1) : e.selectionMode === "year" && n("update:year", v.value[0] - 1);
    }, f = () => {
      e.selectionMode === "day" ? e.month === 12 ? (n("update:year", e.year + 1), n("update:month", 1)) : n("update:month", e.month + 1) : e.selectionMode === "year" && n("update:year", v.value[v.value.length - 1] + 1);
    }, $ = (M) => {
      n("dateClick", new Date(e.year, e.month - 1, M));
    }, V = (M) => {
      n("dateHover", new Date(e.year, e.month - 1, M));
    }, h = (M) => {
      n("update:month", M + 1), n("update:selectionMode", "day");
    }, O = (M) => {
      n("update:year", M), n("update:selectionMode", "month");
    }, R = `text-gray-800 transition-colors duration-100 ${ke} after:z-0 hover:after:bg-gray-200/25`, F = (M) => {
      const E = new Date(e.year, e.month - 1, M);
      if (e.selectedDate && De(E, e.selectedDate))
        return `text-white ${ke} after:bg-green-700 after:z-0`;
      if (!e.selectedRange) return R;
      const [S, W] = e.selectedRange, A = S && !W && e.hoverDate && e.hoverDate >= S && !De(e.hoverDate, S), C = W || (A ? e.hoverDate : null), I = S ? De(E, S) : !1, le = C ? De(E, C) : !1, se = !!(S && C && !De(S, C));
      if (le && !W && A) {
        const b = E.getDay();
        let U = `text-gray-800 ${Se} ${ke} after:z-[1] hover:after:bg-[#F4F5F7] range-end`;
        return (b === 0 || M === 1) && (U += " range-row-start"), U;
      }
      if (I || le) {
        const b = E.getDay();
        let U = `text-white ${ke} after:bg-green-700 after:z-[1]`;
        return I && se && (U += ` ${Se} range-start`, (b === 6 || M === o.value) && (U += " range-row-end")), le && se && (U += ` ${Se} range-end`, (b === 0 || M === 1) && (U += " range-row-start")), U;
      }
      if (S && C && At(E, [S, C])) {
        const b = E.getDay();
        let U = `text-gray-800 transition-colors duration-100 ${Se} ${ke} after:z-0 range-in`;
        return (b === 0 || M === 1) && (U += " range-row-start"), (b === 6 || M === o.value) && (U += " range-row-end"), U;
      }
      return R;
    }, B = `text-white ${Qe} after:bg-green-700`, L = `text-gray-800 ${Qe} hover:after:bg-gray-200/25`, T = (M) => M + 1 === e.month ? B : L, _ = (M) => M === e.year ? B : L;
    return (M, E) => (u(), g("div", Dt, [
      c("div", kt, [
        w.value ? (u(), g("button", {
          key: 0,
          class: "absolute left-0 size-[26px] flex items-center justify-center cursor-pointer rounded-[6px] hover:bg-gray-200/35",
          onClick: i
        }, [
          k(ee, {
            size: 18,
            name: "ChevronUp",
            class: "stroke-gray-800 -rotate-90"
          })
        ])) : H("", !0),
        t.selectionMode !== "year" && !t.disabled ? (u(), g("button", {
          key: 1,
          class: "flex items-center gap-1 text-[15px] leading-[32px] font-medium text-gray-800 font-secondary cursor-pointer rounded-[6px] px-2 h-8 hover:bg-gray-200/25",
          onClick: de(p, ["stop"])
        }, [
          ie(P(s.value) + " ", 1),
          k(ee, {
            size: 12,
            name: "ChevronUp",
            class: "stroke-gray-400 rotate-180"
          })
        ])) : (u(), g("span", wt, P(s.value), 1)),
        r.value ? (u(), g("button", {
          key: 3,
          class: "absolute right-0 size-[26px] flex items-center justify-center cursor-pointer rounded-[6px] hover:bg-gray-200/35",
          onClick: f
        }, [
          k(ee, {
            size: 18,
            name: "ChevronUp",
            class: "stroke-gray-800 rotate-90"
          })
        ])) : H("", !0)
      ]),
      t.selectionMode === "day" ? (u(), g("div", {
        key: 0,
        class: j(["grid grid-cols-7 gap-y-1 mt-1", t.disabled ? "opacity-40 pointer-events-none" : ""])
      }, [
        (u(!0), g(te, null, oe(Z(yt), (S) => (u(), g("div", {
          key: S,
          class: "h-[34px] flex items-center justify-center text-[13px] text-gray-500 font-secondary"
        }, P(S), 1))), 128)),
        a.value ? (u(), g("div", {
          key: 0,
          style: Me({ gridColumn: `span ${a.value}` }),
          class: "h-[34px]"
        }, null, 4)) : H("", !0),
        (u(!0), g(te, null, oe(o.value, (S) => (u(), g("div", {
          key: S,
          class: j(["h-[34px] flex items-center justify-center text-[14px] font-secondary relative", [F(S), t.disabled ? "" : "cursor-pointer"]]),
          onClick: (W) => $(S),
          onMouseenter: (W) => V(S),
          onMouseleave: E[0] || (E[0] = (W) => n("dateHover", null))
        }, [
          c("span", Ct, P(S), 1)
        ], 42, Vt))), 128))
      ], 2)) : H("", !0),
      t.selectionMode === "month" ? (u(), g("div", $t, [
        (u(!0), g(te, null, oe(Z(He), (S, W) => (u(), g("div", {
          key: W,
          class: j(["h-[72px] flex items-center justify-center text-[14px] font-secondary cursor-pointer relative", T(W)]),
          onClick: de((A) => h(W), ["stop"])
        }, [
          c("span", St, P(S.substring(0, 3)), 1)
        ], 10, Mt))), 128))
      ])) : H("", !0),
      t.selectionMode === "year" ? (u(), g("div", Rt, [
        (u(!0), g(te, null, oe(v.value, (S) => (u(), g("div", {
          key: S,
          class: j(["h-[72px] flex items-center justify-center text-[14px] font-secondary cursor-pointer relative", _(S)]),
          onClick: de((W) => O(S), ["stop"])
        }, [
          c("span", Ft, P(S), 1)
        ], 10, zt))), 128))
      ])) : H("", !0)
    ]));
  }
}), Ue = /* @__PURE__ */ pe(It, [["__scopeId", "data-v-40c080f2"]]), Fe = [
  {
    id: "today",
    label: "Today",
    shortLabel: "1D",
    getValue: () => {
      const t = /* @__PURE__ */ new Date();
      t.setHours(0, 0, 0, 0);
      const l = new Date(t);
      return l.setHours(23, 59, 59, 999), [t, l];
    }
  },
  {
    id: "last-7-days",
    label: "Last 7 days",
    shortLabel: "1W",
    getValue: () => {
      const t = /* @__PURE__ */ new Date();
      t.setHours(23, 59, 59, 999);
      const l = /* @__PURE__ */ new Date();
      return l.setDate(l.getDate() - 6), l.setHours(0, 0, 0, 0), [l, t];
    }
  },
  {
    id: "last-4-weeks",
    label: "Last 4 weeks",
    shortLabel: "4W",
    getValue: () => {
      const t = /* @__PURE__ */ new Date();
      t.setHours(23, 59, 59, 999);
      const l = /* @__PURE__ */ new Date();
      return l.setDate(l.getDate() - 27), l.setHours(0, 0, 0, 0), [l, t];
    }
  },
  {
    id: "last-6-months",
    label: "Last 6 months",
    shortLabel: "6M",
    getValue: () => {
      const t = /* @__PURE__ */ new Date();
      t.setHours(23, 59, 59, 999);
      const l = /* @__PURE__ */ new Date();
      return l.setMonth(l.getMonth() - 6), l.setHours(0, 0, 0, 0), [l, t];
    }
  },
  {
    id: "last-12-months",
    label: "Last 12 months",
    shortLabel: "1Y",
    getValue: () => {
      const t = /* @__PURE__ */ new Date();
      t.setHours(23, 59, 59, 999);
      const l = /* @__PURE__ */ new Date();
      return l.setFullYear(l.getFullYear() - 1), l.setHours(0, 0, 0, 0), [l, t];
    }
  },
  {
    id: "month-to-date",
    label: "Month to date",
    shortLabel: "MTD",
    getValue: () => {
      const t = /* @__PURE__ */ new Date();
      return t.setHours(23, 59, 59, 999), [new Date(t.getFullYear(), t.getMonth(), 1), t];
    }
  },
  {
    id: "quarter-to-date",
    label: "Quarter to date",
    shortLabel: "QTD",
    getValue: () => {
      const t = /* @__PURE__ */ new Date();
      t.setHours(23, 59, 59, 999);
      const l = Math.floor(t.getMonth() / 3) * 3;
      return [new Date(t.getFullYear(), l, 1), t];
    }
  },
  {
    id: "year-to-date",
    label: "Year to date",
    shortLabel: "YTD",
    getValue: () => {
      const t = /* @__PURE__ */ new Date();
      return t.setHours(23, 59, 59, 999), [new Date(t.getFullYear(), 0, 1), t];
    }
  },
  {
    id: "all-time",
    label: "All time",
    shortLabel: "ALL",
    getValue: () => {
      const t = /* @__PURE__ */ new Date();
      return t.setHours(23, 59, 59, 999), [null, t];
    }
  }
], Tt = [
  "last-7-days",
  "last-4-weeks",
  "last-6-months",
  "last-12-months",
  "month-to-date",
  "quarter-to-date",
  "year-to-date",
  "all-time"
], Et = Fe.filter(
  (t) => Tt.includes(t.id)
), Ut = { class: "flex flex-col" }, Bt = ["onClick"], _t = /* @__PURE__ */ K({
  __name: "DatePickerPresets",
  props: {
    activePreset: {}
  },
  emits: ["select"],
  setup(t) {
    return (l, e) => (u(), g("div", Ut, [
      (u(!0), g(te, null, oe(Z(Fe), (n) => (u(), g("button", {
        key: n.id,
        class: j(["h-[34px] w-[131px] mx-1 px-2.5 text-left text-[14px] text-gray-800 font-secondary cursor-pointer select-none rounded-[6px] hover:bg-gray-200/25", { "bg-gray-200/25": t.activePreset?.id === n.id }]),
        onClick: (o) => l.$emit("select", n)
      }, P(n.label), 11, Bt))), 128))
    ]));
  }
}), Lt = { class: "relative bg-white rounded-[6px]" }, Pt = ["for"], Yt = ["id", "value", "disabled"], Ht = {
  ref: "mirrorRef",
  "aria-hidden": "true",
  class: "absolute inset-0 pointer-events-none overflow-hidden border border-transparent font-secondary flex items-center whitespace-pre tabular-nums z-[2] h-[30px] px-[9px] py-[5px] text-[14px]"
}, Ot = {
  key: 0,
  class: "flex items-center gap-1.5 mt-1.5"
}, Qt = { class: "font-secondary text-[12px] font-medium text-red-500" }, qt = /* @__PURE__ */ K({
  __name: "DateInput",
  props: {
    modelValue: { default: "" },
    disabled: { type: Boolean },
    label: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const e = [
      { placeholder: "MM", maxDigits: 2, start: 0, end: 2 },
      { placeholder: "DD", maxDigits: 2, start: 5, end: 7 },
      { placeholder: "YYYY", maxDigits: 4, start: 10, end: 14 }
    ], n = t, o = l, a = x(null), v = x(null), w = x(null), r = x(null), s = x(0), p = x(!1), i = x(!1), f = x(T(n.modelValue)), $ = x({}), V = z(() => [v.value, w.value, r.value]), h = x(""), O = z(() => i.value), R = z(
      () => n.label.toLowerCase().replace(/\W+/g, " ").trim().replace(/\s/g, "-")
    ), F = z(() => n.disabled ? "bg-gray-900/3 border-gray-200/50 text-gray-500/50! pointer-events-none" : h.value ? "border-red-500 hover:border-red-500 focus:border-red-500 focus:outline-solid focus:outline-2 focus:outline-red-200/50" : "border-gray-200 hover:border-gray-300 focus:border-green-500 focus:outline-solid focus:outline-2 focus:outline-green-200/50"), B = z(
      () => e.map((m, D) => {
        const Y = f.value[D];
        return Y ? Y.length < m.maxDigits ? D === 2 ? Y + " ".repeat(m.maxDigits - Y.length) : Y === "0" ? "0" + " ".repeat(m.maxDigits - 1) : Y.padStart(m.maxDigits, "0") : Y : m.placeholder;
      }).join(" / ")
    ), L = z(
      () => e.map((m, D) => {
        const Y = f.value[D];
        return Y ? Y.length >= m.maxDigits || D === 2 && Y.startsWith("0") ? Y : Y === "0" ? "0" : Y.padStart(m.maxDigits, "0") : m.placeholder;
      })
    );
    function T(m) {
      if (!m?.trim()) return ["", "", ""];
      const D = m.split(" / ");
      return e.map((Y, G) => (D[G] ?? "").replace(/\D/g, ""));
    }
    re(
      () => n.modelValue,
      (m) => {
        if (m === B.value) return;
        const D = T(m);
        D[0] === f.value[0] && D[1] === f.value[1] && D[2] === f.value[2] || (f.value = D);
      }
    );
    function _() {
      o("update:modelValue", B.value);
    }
    function M() {
      const m = V.value[s.value], D = a.value?.parentElement;
      if (!m || !D) return;
      const Y = m.getBoundingClientRect(), G = D.getBoundingClientRect();
      $.value = {
        left: `${Y.left - G.left - 3}px`,
        top: `${Y.top - G.top}px`,
        width: `${Y.width + 6}px`,
        height: `${Y.height}px`
      };
    }
    function E(m) {
      s.value = m, p.value = !1, ce(() => {
        const D = e[m];
        a.value?.setSelectionRange(D.start, D.end), M();
      });
    }
    function S() {
      const m = s.value, D = f.value[m], Y = m === 2 || D === "0" ? e[m].start + D.length : e[m].end;
      ce(() => a.value?.setSelectionRange(Y, Y));
    }
    function W() {
      E(s.value < 2 ? s.value + 1 : 2);
    }
    function A(m) {
      const D = s.value, Y = e[D];
      if (p.value)
        f.value[D] += m, _(), f.value[D].length >= Y.maxDigits ? W() : S();
      else {
        f.value[D] = "", p.value = !0;
        const G = parseInt(m, 10);
        if (D === 0 && G >= 2 || D === 1 && G >= 4) {
          f.value[D] = "0" + m, _(), W();
          return;
        }
        f.value[D] = m, _(), S();
      }
    }
    function C() {
      const m = s.value;
      p.value ? (f.value[m] = f.value[m].slice(0, -1), _(), f.value[m] ? S() : E(m)) : !f.value[m] && m > 0 ? (f.value[m - 1] = "", _(), E(m - 1)) : (f.value[m] = "", _(), E(m));
    }
    function I(m) {
      const D = s.value, Y = f.value[D], G = e[D];
      let X;
      Y ? (X = parseInt(Y, 10) + m, D === 0 ? X = X > 12 ? 1 : X < 1 ? 12 : X : D === 1 ? X = X > 31 ? 1 : X < 1 ? 31 : X : X = Math.max(1, Math.min(9999, X))) : X = D === 2 ? (/* @__PURE__ */ new Date()).getFullYear() : m > 0 ? 1 : D === 0 ? 12 : 31, f.value[D] = String(X).padStart(G.maxDigits, "0"), _(), E(D);
    }
    function le(m) {
      const D = V.value, Y = m.clientX;
      for (let G = 0; G < D.length; G++) {
        const X = D[G];
        if (!X) continue;
        const fe = X.getBoundingClientRect();
        if (G < D.length - 1) {
          const d = D[G + 1];
          if (d) {
            const y = d.getBoundingClientRect(), q = (fe.right + y.left) / 2;
            if (Y < q) return G;
          }
        } else
          return G;
      }
      return 2;
    }
    function se(m) {
      a.value?.focus(), E(le(m));
    }
    function ve() {
      const [m, D, Y] = f.value;
      if (!m && !D && !Y) return !0;
      if (m.length < 2 || D.length < 2 || Y.length < 4) return !1;
      const G = parseInt(m, 10), X = parseInt(D, 10), fe = parseInt(Y, 10);
      if (G < 1 || G > 12 || X < 1 || X > 31 || fe < 1) return !1;
      const d = new Date(fe, G - 1, X);
      return d.getMonth() === G - 1 && d.getDate() === X;
    }
    function b() {
      h.value = "", i.value = !0, E(0);
    }
    function U() {
      i.value = !1, p.value = !1, h.value = ve() ? "" : "Invalid date";
    }
    function ae(m) {
      if (!(m.ctrlKey || m.metaKey)) {
        if (m.key === "Tab") {
          m.shiftKey ? s.value > 0 && (m.preventDefault(), E(s.value - 1)) : s.value < 2 && (m.preventDefault(), E(s.value + 1));
          return;
        }
        m.preventDefault(), m.key >= "0" && m.key <= "9" ? A(m.key) : m.key === "Backspace" ? C() : m.key === "ArrowRight" && s.value < 2 ? E(s.value + 1) : m.key === "ArrowLeft" && s.value > 0 ? E(s.value - 1) : m.key === "ArrowUp" ? I(1) : m.key === "ArrowDown" && I(-1);
      }
    }
    return (m, D) => (u(), g("div", null, [
      c("div", Lt, [
        c("label", {
          for: R.value,
          class: "sr-only"
        }, P(t.label), 9, Pt),
        c("input", {
          id: R.value,
          ref_key: "inputRef",
          ref: a,
          type: "text",
          value: B.value,
          disabled: t.disabled,
          class: j(["peer w-full appearance-none bg-transparent border text-transparent outline-hidden font-secondary relative z-[3] tabular-nums h-[30px] px-[9px] py-[5px] text-[14px] rounded-[6px]", [F.value, "caret-transparent"]]),
          onMousedown: de(se, ["prevent"]),
          onFocus: b,
          onKeydown: ae,
          onBlur: U
        }, null, 42, Yt),
        c("div", Ht, [
          c("span", {
            ref_key: "seg0Ref",
            ref: v,
            class: "relative inline-flex"
          }, [
            D[0] || (D[0] = c("span", { class: "invisible" }, "MM", -1)),
            c("span", {
              class: j(["absolute inset-0 flex items-center justify-center", f.value[0] ? "text-gray-800" : "text-gray-500"])
            }, P(L.value[0]), 3)
          ], 512),
          D[3] || (D[3] = c("span", { class: "text-gray-800" }, " / ", -1)),
          c("span", {
            ref_key: "seg1Ref",
            ref: w,
            class: "relative inline-flex"
          }, [
            D[1] || (D[1] = c("span", { class: "invisible" }, "DD", -1)),
            c("span", {
              class: j(["absolute inset-0 flex items-center justify-center", f.value[1] ? "text-gray-800" : "text-gray-500"])
            }, P(L.value[1]), 3)
          ], 512),
          D[4] || (D[4] = c("span", { class: "text-gray-800" }, " / ", -1)),
          c("span", {
            ref_key: "seg2Ref",
            ref: r,
            class: "relative inline-flex"
          }, [
            D[2] || (D[2] = c("span", { class: "invisible" }, "YYYY", -1)),
            c("span", {
              class: j(["absolute inset-0 flex items-center justify-center", f.value[2] ? "text-gray-800" : "text-gray-500"])
            }, P(L.value[2]), 3)
          ], 512)
        ], 512),
        O.value ? (u(), g("div", {
          key: 0,
          class: "absolute pointer-events-none bg-green-200 z-[1] rounded-sm",
          style: Me($.value)
        }, null, 4)) : H("", !0)
      ]),
      h.value ? (u(), g("div", Ot, [
        k(ee, {
          name: "Alert",
          size: 12,
          class: "stroke-red-500"
        }),
        c("span", Qt, P(h.value), 1)
      ])) : H("", !0)
    ]));
  }
}), he = /* @__PURE__ */ pe(qt, [["__scopeId", "data-v-887f4878"]]), Nt = { class: "px-1.5 py-[5px]" }, jt = {
  key: 0,
  class: "flex gap-x-[30px]"
}, Wt = { class: "flex items-start gap-2.5" }, Kt = { class: "w-[125px]" }, Gt = { class: "flex items-start gap-2.5" }, Jt = { class: "w-[125px]" }, Xt = {
  key: 1,
  class: "w-full"
}, Zt = /* @__PURE__ */ K({
  __name: "DatePickerHeader",
  props: {
    mode: {},
    selectedDate: { default: null },
    startDate: { default: null },
    endDate: { default: null }
  },
  emits: ["dateInput", "startDateInput", "endDateInput"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = x(ne(e.selectedDate)), a = x(ne(e.startDate)), v = x(ne(e.endDate)), w = (p) => {
      o.value = p;
      const i = xe(p);
      i && n("dateInput", i);
    }, r = (p) => {
      a.value = p;
      const i = xe(p);
      i && n("startDateInput", i);
    }, s = (p) => {
      v.value = p;
      const i = xe(p);
      i && n("endDateInput", i);
    };
    return re(
      () => e.selectedDate,
      (p) => {
        o.value = ne(p);
      }
    ), re(
      () => e.startDate,
      (p) => {
        a.value = ne(p);
      }
    ), re(
      () => e.endDate,
      (p) => {
        v.value = ne(p);
      }
    ), (p, i) => (u(), g("div", Nt, [
      t.mode === "range" ? (u(), g("div", jt, [
        c("div", Wt, [
          i[0] || (i[0] = c("div", { class: "h-[30px] flex items-center text-[13px] leading-[18px] font-medium text-gray-500 font-secondary" }, " Start ", -1)),
          c("div", Kt, [
            k(he, {
              label: "Start date",
              size: "md",
              "model-value": a.value,
              "onUpdate:modelValue": r
            }, null, 8, ["model-value"])
          ])
        ]),
        c("div", Gt, [
          i[1] || (i[1] = c("div", { class: "h-[30px] flex items-center text-[13px] leading-[18px] font-medium text-gray-500 font-secondary" }, " End ", -1)),
          c("div", Jt, [
            k(he, {
              label: "End date",
              size: "md",
              "model-value": v.value,
              "onUpdate:modelValue": s
            }, null, 8, ["model-value"])
          ])
        ])
      ])) : (u(), g("div", Xt, [
        k(he, {
          label: "Date",
          size: "md",
          "model-value": o.value,
          "onUpdate:modelValue": w
        }, null, 8, ["model-value"])
      ]))
    ]));
  }
}), el = { class: "flex" }, tl = { class: "flex flex-col p-1" }, ll = { class: "flex gap-x-[50px] p-2.5" }, al = {
  key: 0,
  class: "flex items-center justify-end gap-1.5 p-1.5"
}, Re = /* @__PURE__ */ K({
  __name: "DatePicker",
  props: {
    modelValue: {},
    mode: { default: "single" },
    view: { default: "single" },
    presets: { type: Boolean }
  },
  emits: ["update:modelValue", "presetSelect"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = /* @__PURE__ */ new Date(), a = x(o.getFullYear()), v = x(o.getMonth() + 1), w = x("day"), r = x(v.value === 1 ? a.value - 1 : a.value), s = x(v.value === 1 ? 12 : v.value - 1), p = x("day"), i = x(null), f = x([null, null]), $ = x(!0), V = x(null), h = x(null), O = (b) => {
      e.mode === "range" && !$.value && f.value[0] && !f.value[1] && (h.value = b);
    }, R = () => {
      if (e.mode === "single" && e.modelValue && !Array.isArray(e.modelValue) && (i.value = e.modelValue, a.value = i.value.getFullYear(), v.value = i.value.getMonth() + 1), e.mode === "range" && e.modelValue && Array.isArray(e.modelValue)) {
        f.value = [...e.modelValue];
        const b = f.value[1] || f.value[0];
        b && (a.value = b.getFullYear(), v.value = b.getMonth() + 1);
      }
      F();
    }, F = () => {
      v.value === 1 ? (r.value = a.value - 1, s.value = 12) : (r.value = a.value, s.value = v.value - 1);
    }, B = (b) => {
      a.value = b, F();
    }, L = (b) => {
      v.value = b, F();
    }, T = (b) => {
      a.value = b, v.value = s.value === 12 ? 1 : s.value + 1, s.value === 12 ? a.value = b + 1 : a.value = b, r.value = b;
    }, _ = (b) => {
      s.value = b, r.value = r.value, b === 12 ? (a.value = r.value + 1, v.value = 1) : (a.value = r.value, v.value = b + 1);
    }, M = (b) => {
      a.value = b.getFullYear(), v.value = b.getMonth() + 1, F();
    }, E = (b) => {
      i.value = b, M(b), n("update:modelValue", b);
    }, S = (b) => {
      V.value = null, f.value = [b, f.value[1]], M(b);
    }, W = (b) => {
      V.value = null;
      const U = new Date(b);
      U.setHours(23, 59, 59, 999), f.value = [f.value[0], U], M(b);
    }, A = (b) => {
      if (e.mode === "single") {
        i.value = b, n("update:modelValue", b);
        return;
      }
      V.value = null;
      const [U, ae] = f.value;
      if ($.value || !U)
        f.value = [b, null], $.value = !1;
      else {
        if (b >= U) {
          const m = new Date(b);
          m.setHours(23, 59, 59, 999), f.value = [U, m];
        } else {
          f.value = [b, null], $.value = !1;
          return;
        }
        $.value = !0, h.value = null;
      }
    }, C = (b) => {
      V.value = b;
      const U = b.getValue();
      f.value = [...U], $.value = !0;
      const ae = U[1] || U[0];
      ae && (a.value = ae.getFullYear(), v.value = ae.getMonth() + 1, F());
    }, I = () => {
      f.value = [null, null], V.value = null, $.value = !0;
    }, le = (b, U) => !b || !U ? b === U : b.getFullYear() === U.getFullYear() && b.getMonth() === U.getMonth() && b.getDate() === U.getDate(), se = () => {
      if (!e.presets) return null;
      const [b, U] = f.value;
      if (!b || !U) return null;
      for (const ae of Fe) {
        const [m, D] = ae.getValue();
        if (m && D && le(b, m) && le(U, D))
          return ae;
      }
      return null;
    }, ve = () => {
      const b = V.value?.label ?? se()?.label ?? null;
      n("presetSelect", b), n("update:modelValue", [...f.value]);
    };
    return re(
      () => e.modelValue,
      () => R(),
      { immediate: !0 }
    ), (b, U) => (u(), J(_e, { class: "w-fit" }, {
      default: N(() => [
        c("div", el, [
          t.presets ? (u(), J(_t, {
            key: 0,
            "active-preset": V.value,
            onSelect: C
          }, null, 8, ["active-preset"])) : H("", !0),
          c("div", tl, [
            k(Zt, {
              mode: t.mode,
              "selected-date": t.mode === "single" ? i.value : void 0,
              "start-date": t.mode === "range" ? f.value[0] : void 0,
              "end-date": t.mode === "range" ? f.value[1] : void 0,
              onDateInput: E,
              onStartDateInput: S,
              onEndDateInput: W
            }, null, 8, ["mode", "selected-date", "start-date", "end-date"]),
            c("div", ll, [
              t.view === "double" ? (u(), J(Ue, {
                key: 0,
                year: r.value,
                month: s.value,
                "selection-mode": p.value,
                "selected-date": t.mode === "single" ? i.value : void 0,
                "selected-range": t.mode === "range" ? f.value : void 0,
                "hover-date": h.value,
                disabled: w.value !== "day",
                "show-prev-arrow": !0,
                "show-next-arrow": !1,
                "onUpdate:year": T,
                "onUpdate:month": _,
                "onUpdate:selectionMode": U[0] || (U[0] = (ae) => p.value = ae),
                onDateClick: A,
                onDateHover: O
              }, null, 8, ["year", "month", "selection-mode", "selected-date", "selected-range", "hover-date", "disabled"])) : H("", !0),
              k(Ue, {
                year: a.value,
                month: v.value,
                "selection-mode": w.value,
                "selected-date": t.mode === "single" ? i.value : void 0,
                "selected-range": t.mode === "range" ? f.value : void 0,
                "hover-date": h.value,
                disabled: p.value !== "day",
                "show-prev-arrow": t.view === "single",
                "show-next-arrow": !0,
                "onUpdate:year": B,
                "onUpdate:month": L,
                "onUpdate:selectionMode": U[1] || (U[1] = (ae) => w.value = ae),
                onDateClick: A,
                onDateHover: O
              }, null, 8, ["year", "month", "selection-mode", "selected-date", "selected-range", "hover-date", "disabled", "show-prev-arrow"])
            ]),
            t.mode === "range" ? (u(), g("div", al, [
              k(ye, {
                variant: "stroke",
                size: "md",
                onClick: I
              }, {
                default: N(() => [...U[2] || (U[2] = [
                  ie("Clear", -1)
                ])]),
                _: 1
              }),
              k(ye, {
                variant: "primary",
                size: "md",
                onClick: ve
              }, {
                default: N(() => [...U[3] || (U[3] = [
                  ie("Apply", -1)
                ])]),
                _: 1
              })
            ])) : H("", !0)
          ])
        ])
      ]),
      _: 1
    }));
  }
}), nl = { class: "relative bg-white rounded-[6px]" }, sl = ["for"], ol = ["id", "value"], rl = {
  ref: "mirrorRef",
  "aria-hidden": "true",
  class: "absolute inset-0 pointer-events-none overflow-hidden border border-transparent font-secondary flex items-center whitespace-pre tabular-nums z-[2] h-[30px] px-[9px] py-[5px] text-[14px]"
}, ul = { class: "absolute inset-0 flex items-center justify-center text-gray-800" }, il = {
  key: 0,
  class: "flex items-center gap-1.5 mt-1.5"
}, dl = { class: "font-secondary text-[12px] font-medium text-red-500" }, cl = /* @__PURE__ */ K({
  __name: "TimeInput",
  props: {
    modelValue: { default: "" },
    label: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const e = [
      { placeholder: "HH", maxDigits: 2, start: 0, end: 2 },
      { placeholder: "MM", maxDigits: 2, start: 5, end: 7 }
    ], n = t, o = l, a = x(null), v = x(null), w = x(null), r = x(null), s = x(0), p = x(!1), i = x(!1), f = x({}), { digits: $, period: V } = W(n.modelValue), h = x($), O = x(V || "AM"), R = z(() => [v.value, w.value, r.value]), F = x(""), B = z(() => i.value), L = z(
      () => n.label.toLowerCase().replace(/\W+/g, " ").trim().replace(/\s/g, "-")
    ), T = z(() => F.value ? "border-red-500 hover:border-red-500 focus:border-red-500 focus:outline-solid focus:outline-2 focus:outline-red-200/50" : "border-gray-200 hover:border-gray-300 focus:border-green-500 focus:outline-solid focus:outline-2 focus:outline-green-200/50"), _ = z(() => {
      const d = E(0), y = E(1);
      return `${d} : ${y}${O.value}`;
    }), M = z(() => [S(0), S(1)]);
    function E(d) {
      const y = h.value[d], q = e[d];
      return y ? y.length < q.maxDigits ? y === "0" ? "0" + " ".repeat(q.maxDigits - 1) : y.padStart(q.maxDigits, "0") : y : q.placeholder;
    }
    function S(d) {
      const y = h.value[d], q = e[d];
      return y ? y.length >= q.maxDigits ? y : y === "0" ? "0" : y.padStart(q.maxDigits, "0") : q.placeholder;
    }
    function W(d) {
      if (!d?.trim()) return { digits: ["", ""], period: "" };
      const y = d.split(" : "), q = (y[0] ?? "").replace(/\D/g, ""), Ae = (y[1] ?? "").trim().split(/\s+/), Ie = (Ae[0] ?? "").replace(/\D/g, ""), me = (Ae[1] ?? "").toUpperCase();
      return { digits: [q, Ie], period: me === "AM" || me === "PM" ? me : "" };
    }
    re(
      () => n.modelValue,
      (d) => {
        if (d === _.value) return;
        const y = W(d);
        y.digits[0] === h.value[0] && y.digits[1] === h.value[1] && y.period === O.value || (h.value = y.digits, O.value = y.period || "AM");
      }
    );
    function A() {
      o("update:modelValue", _.value);
    }
    function C() {
      const d = R.value[s.value], y = a.value?.parentElement;
      if (!d || !y) return;
      const q = d.getBoundingClientRect(), Q = y.getBoundingClientRect();
      f.value = {
        left: `${q.left - Q.left - 3}px`,
        top: `${q.top - Q.top}px`,
        width: `${q.width + 6}px`,
        height: `${q.height}px`
      };
    }
    function I(d) {
      s.value = d, p.value = !1, ce(() => {
        if (d < 2) {
          const y = e[d];
          a.value?.setSelectionRange(y.start, y.end);
        } else
          a.value?.setSelectionRange(7, 9);
        C();
      });
    }
    function le() {
      const d = s.value;
      if (d >= 2) return;
      const y = h.value[d], q = y === "0" ? e[d].start + y.length : e[d].end;
      ce(() => a.value?.setSelectionRange(q, q));
    }
    function se() {
      I(s.value < 2 ? s.value + 1 : 2);
    }
    function ve(d) {
      const y = s.value;
      if (y === 2) return;
      const q = e[y];
      if (p.value) {
        let Q = h.value[y] + d;
        y === 0 && parseInt(Q, 10) > 12 && (Q = "12"), h.value[y] = Q, A(), h.value[y].length >= q.maxDigits ? se() : le();
      } else {
        h.value[y] = "", p.value = !0;
        const Q = parseInt(d, 10);
        if (y === 0 && Q >= 2) {
          h.value[y] = "0" + d, A(), se();
          return;
        }
        if (y === 1 && Q >= 6) {
          h.value[y] = "0" + d, A(), se();
          return;
        }
        h.value[y] = d, A(), le();
      }
    }
    function b() {
      const d = s.value;
      if (d === 2) {
        h.value[1] = "", A(), I(1);
        return;
      }
      p.value ? (h.value[d] = h.value[d].slice(0, -1), A(), h.value[d] ? le() : I(d)) : !h.value[d] && d > 0 ? (h.value[d - 1] = "", A(), I(d - 1)) : (h.value[d] = "", A(), I(d));
    }
    function U(d) {
      const y = s.value;
      if (y === 2) {
        O.value = O.value === "AM" ? "PM" : "AM", A(), I(2);
        return;
      }
      const q = h.value[y];
      let Q;
      q ? (Q = parseInt(q, 10) + d, y === 0 ? Q = Q > 12 ? 1 : Q < 1 ? 12 : Q : Q = Q > 59 ? 0 : Q < 0 ? 59 : Q) : y === 0 ? Q = d > 0 ? 1 : 12 : Q = d > 0 ? 0 : 59, h.value[y] = String(Q).padStart(e[y].maxDigits, "0"), A(), I(y);
    }
    function ae(d) {
      d === "a" || d === "A" ? O.value = "AM" : (d === "p" || d === "P") && (O.value = "PM"), A(), I(2);
    }
    function m(d) {
      const y = R.value, q = d.clientX;
      for (let Q = 0; Q < y.length; Q++) {
        const Ae = y[Q];
        if (!Ae) continue;
        const Ie = Ae.getBoundingClientRect();
        if (Q < y.length - 1) {
          const me = y[Q + 1];
          if (me) {
            const Le = me.getBoundingClientRect(), at = (Ie.right + Le.left) / 2;
            if (q < at) return Q;
          }
        } else
          return Q;
      }
      return 2;
    }
    function D(d) {
      a.value?.focus(), I(m(d));
    }
    function Y() {
      const [d, y] = h.value;
      if (!d && !y) return !0;
      if (d.length < 2 || y.length < 2) return !1;
      const q = parseInt(d, 10), Q = parseInt(y, 10);
      return !(q < 1 || q > 12 || Q < 0 || Q > 59);
    }
    function G() {
      F.value = "", i.value = !0, I(0);
    }
    function X() {
      i.value = !1, p.value = !1, F.value = Y() ? "" : "Invalid time";
    }
    function fe(d) {
      if (!(d.ctrlKey || d.metaKey)) {
        if (d.key === "Tab") {
          d.shiftKey ? s.value > 0 && (d.preventDefault(), I(s.value - 1)) : s.value < 2 && (d.preventDefault(), I(s.value + 1));
          return;
        }
        d.preventDefault(), d.key >= "0" && d.key <= "9" ? ve(d.key) : d.key === "a" || d.key === "A" || d.key === "p" || d.key === "P" ? s.value === 2 && ae(d.key) : d.key === "Backspace" ? b() : d.key === "ArrowRight" && s.value < 2 ? I(s.value + 1) : d.key === "ArrowLeft" && s.value > 0 ? I(s.value - 1) : d.key === "ArrowUp" ? U(1) : d.key === "ArrowDown" && U(-1);
      }
    }
    return (d, y) => (u(), g("div", null, [
      c("div", nl, [
        c("label", {
          for: L.value,
          class: "sr-only"
        }, P(t.label), 9, sl),
        c("input", {
          id: L.value,
          ref_key: "inputRef",
          ref: a,
          type: "text",
          value: _.value,
          class: j(["peer appearance-none bg-transparent border text-transparent outline-hidden font-secondary relative z-[3] tabular-nums h-[30px] w-[100px] px-[9px] py-[5px] text-[14px] rounded-[6px]", [T.value, "caret-transparent"]]),
          onMousedown: de(D, ["prevent"]),
          onFocus: G,
          onKeydown: fe,
          onBlur: X
        }, null, 42, ol),
        c("div", rl, [
          c("span", {
            ref_key: "seg0Ref",
            ref: v,
            class: "relative inline-flex"
          }, [
            y[0] || (y[0] = c("span", { class: "invisible" }, "HH", -1)),
            c("span", {
              class: j(["absolute inset-0 flex items-center justify-center", h.value[0] ? "text-gray-800" : "text-gray-500"])
            }, P(M.value[0]), 3)
          ], 512),
          y[3] || (y[3] = c("span", { class: "text-gray-800" }, " : ", -1)),
          c("span", {
            ref_key: "seg1Ref",
            ref: w,
            class: "relative inline-flex"
          }, [
            y[1] || (y[1] = c("span", { class: "invisible" }, "MM", -1)),
            c("span", {
              class: j(["absolute inset-0 flex items-center justify-center", h.value[1] ? "text-gray-800" : "text-gray-500"])
            }, P(M.value[1]), 3)
          ], 512),
          c("span", {
            ref_key: "seg2Ref",
            ref: r,
            class: "relative inline-flex ml-2"
          }, [
            y[2] || (y[2] = c("span", { class: "invisible" }, "AM", -1)),
            c("span", ul, P(O.value), 1)
          ], 512)
        ], 512),
        B.value ? (u(), g("div", {
          key: 0,
          class: "absolute pointer-events-none bg-green-200 z-[1] rounded-sm",
          style: Me(f.value)
        }, null, 4)) : H("", !0)
      ]),
      F.value ? (u(), g("div", il, [
        k(ee, {
          name: "Alert",
          size: 12,
          class: "stroke-red-500"
        }),
        c("span", dl, P(F.value), 1)
      ])) : H("", !0)
    ]));
  }
}), Ee = /* @__PURE__ */ pe(cl, [["__scopeId", "data-v-27678293"]]), pl = { class: "relative" }, vl = {
  key: 0,
  class: "flex-1 min-w-0 truncate pr-[30px]"
}, fl = ["value", "disabled"], ml = {
  value: "",
  disabled: "",
  selected: ""
}, gl = ["value"], yl = {
  key: 0,
  class: "flex items-center gap-1.5 mt-1.5"
}, xl = { class: "font-secondary text-[12px] font-medium text-red-500" }, ze = /* @__PURE__ */ K({
  __name: "Select",
  props: {
    modelValue: {},
    label: {},
    options: {},
    size: { default: "md" },
    disabled: { type: Boolean },
    error: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const l = t, e = z(() => l.modelValue ? l.options.find((s) => s.value === l.modelValue)?.label ?? "" : ""), n = z(() => l.size === "xl" ? 18 : 15), o = {
      md: "h-[30px] px-[9px] py-[5px] text-[14px] rounded-[6px]",
      lg: "h-[38px] px-[13px] py-[10.5px] text-[14px] rounded-[7px]",
      xl: "h-12 px-[15px] pt-[22px] pb-[6px] text-[14px] rounded-lg"
    }, a = {
      md: "gap-[8px]",
      lg: "gap-[12px]",
      xl: "gap-[12px]"
    }, v = z(() => {
      const r = [
        o[l.size],
        a[l.size],
        l.size === "xl" ? "font-primary" : "font-secondary"
      ];
      return l.disabled ? r.push("bg-gray-900/3 border-gray-200/50 text-gray-800/50! pointer-events-none") : l.error ? r.push(
        "border-red-500 peer-hover:border-red-500 peer-focus:border-red-500 peer-focus:outline-solid peer-focus:outline-2 peer-focus:outline-red-200/50"
      ) : r.push(
        "border-gray-200 peer-hover:border-gray-300 peer-focus:border-green-500 peer-focus:outline-solid peer-focus:outline-2 peer-focus:outline-green-200/50"
      ), r.join(" ");
    }), w = z(() => {
      const r = !!l.modelValue, s = [];
      return r ? s.push("text-[14px] font-medium scale-75 translate-y-0") : s.push("text-[14px] font-[400] scale-100 translate-y-[11px]"), l.disabled ? s.push(r ? "text-gray-500/40" : "text-gray-500/50") : s.push("text-gray-500"), s.join(" ");
    });
    return (r, s) => (u(), g("div", null, [
      c("div", pl, [
        c("div", {
          class: j(["pointer-events-none flex w-full items-center bg-white border outline-hidden", v.value])
        }, [
          t.size === "xl" ? (u(), g("span", vl, [
            e.value ? (u(), g("span", {
              key: 0,
              class: j(["font-primary text-[14px]", t.disabled ? "text-gray-800/50" : "text-gray-800"])
            }, P(e.value), 3)) : H("", !0)
          ])) : (u(), g("span", {
            key: 1,
            class: j(["flex-1 min-w-0 truncate", e.value ? t.disabled ? "text-gray-800/50" : "text-gray-800" : t.disabled ? "text-gray-500/50" : "text-gray-500"])
          }, P(e.value || t.label), 3)),
          k(ee, {
            name: "Select",
            size: n.value,
            class: j(["stroke-gray-500", t.size === "xl" ? "absolute right-3 top-1/2 -translate-y-1/2" : "shrink-0"])
          }, null, 8, ["size", "class"])
        ], 2),
        t.size === "xl" ? (u(), g("span", {
          key: 0,
          class: j(["pointer-events-none absolute left-4 top-[3px] origin-[0] transition-all font-primary", w.value])
        }, P(t.label), 3)) : H("", !0),
        c("select", {
          class: j(["peer absolute inset-0 w-full opacity-0 cursor-pointer", t.disabled ? "pointer-events-none" : ""]),
          value: t.modelValue,
          disabled: t.disabled,
          onChange: s[0] || (s[0] = (p) => r.$emit("update:modelValue", p.target.value))
        }, [
          c("option", ml, P(t.label), 1),
          (u(!0), g(te, null, oe(t.options, (p) => (u(), g("option", {
            key: p.value,
            value: p.value
          }, P(p.label), 9, gl))), 128))
        ], 42, fl)
      ]),
      t.error ? (u(), g("div", yl, [
        k(ee, {
          name: "Alert",
          size: 12,
          class: "stroke-red-500"
        }),
        c("span", xl, P(t.error), 1)
      ])) : H("", !0)
    ]));
  }
}), hl = /* @__PURE__ */ K({
  __name: "Menu",
  props: {
    width: { default: "280px" }
  },
  setup(t) {
    return (l, e) => (u(), J(_e, null, {
      default: N(() => [
        c("div", {
          class: "flex flex-col py-1",
          style: Me({ width: t.width })
        }, [
          ue(l.$slots, "default")
        ], 4)
      ]),
      _: 3
    }));
  }
}), bl = /* @__PURE__ */ K({
  __name: "MenuItem",
  props: {
    icon: {},
    disabled: { type: Boolean }
  },
  emits: ["click"],
  setup(t) {
    return (l, e) => (u(), g("div", {
      class: j(["flex items-center gap-2 h-[34px] px-2.5 py-2 cursor-pointer select-none hover:bg-gray-200/25 rounded-[10px] font-secondary text-[14px] text-gray-800", { "opacity-40 pointer-events-none": t.disabled }]),
      onClick: e[0] || (e[0] = (n) => l.$emit("click"))
    }, [
      t.icon ? (u(), J(ee, {
        key: 0,
        name: t.icon,
        size: 16,
        class: "stroke-gray-800 shrink-0"
      }, null, 8, ["name"])) : H("", !0),
      ue(l.$slots, "default")
    ], 2));
  }
}), Al = {}, Dl = { class: "font-secondary text-[14px] leading-[18px] font-medium pl-[2px] text-gray-800 mb-[7px]" };
function kl(t, l) {
  return u(), g("div", Dl, [
    ue(t.$slots, "default")
  ]);
}
const Ca = /* @__PURE__ */ pe(Al, [["render", kl]]), wl = ["disabled", "onClick"], $a = /* @__PURE__ */ K({
  __name: "PillTabs",
  props: {
    modelValue: {},
    tabs: {},
    size: { default: "md" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = x([]), a = x(0), v = x(0), w = x(0), r = () => {
      const V = o.value?.[a.value];
      V && (v.value = V.offsetLeft, w.value = V.offsetWidth);
    };
    st(() => {
      const V = e.tabs.findIndex((h) => h.value === e.modelValue);
      V >= 0 && (a.value = V);
    }), re(a, () => ce(r)), re(() => e.tabs, () => ce(r)), Ne(r);
    const s = (V) => {
      e.tabs[V].disabled || (a.value = V, n("update:modelValue", e.tabs[V].value));
    }, p = z(() => ({
      "h-8": e.size === "md",
      "h-7": e.size === "sm"
    })), i = z(() => ({
      "h-7": e.size === "md",
      "h-6": e.size === "sm"
    })), f = (V) => {
      const h = e.tabs[V], O = V === a.value;
      return [
        e.size === "md" ? "text-[14px] px-[10px]" : "text-[12px] px-[9px]",
        O ? "opacity-100" : h.disabled ? "opacity-20 pointer-events-none" : "opacity-60"
      ];
    }, $ = z(() => ({
      width: `${w.value}px`,
      left: `${v.value}px`
    }));
    return (V, h) => (u(), g("div", {
      class: j(["relative inline-flex select-none rounded-[30px] bg-gray-800/5 p-[2px]", p.value])
    }, [
      c("div", {
        class: j(["absolute top-[2px] rounded-[30px] bg-white shadow-[0_1px_1px_rgba(66,68,70,0.08)] transition-all", i.value]),
        style: Me($.value)
      }, null, 6),
      (u(!0), g(te, null, oe(t.tabs, (O, R) => (u(), g("button", {
        key: O.value,
        ref_for: !0,
        ref_key: "tabRefs",
        ref: o,
        class: j(["relative z-10 flex items-center justify-center font-primary font-medium text-gray-800 text-center cursor-pointer", f(R)]),
        disabled: O.disabled,
        onClick: (F) => s(R)
      }, P(O.label), 11, wl))), 128))
    ], 2));
  }
}), Vl = 0.3, Cl = 800, $l = /* @__PURE__ */ K({
  __name: "BottomSheet",
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = x(null), a = x(null), v = x(null), w = x(0), r = x(0), s = x(!1), p = x(0), i = x(!1), f = () => n("update:modelValue", !1), $ = (T) => {
      const _ = T, M = _.querySelector(":scope > div:first-child"), E = _.querySelector(":scope > div:last-child");
      M && (M.style.opacity = "0"), E && (E.style.transform = "translateY(100%)");
    }, V = (T, _) => {
      const M = T, E = M.querySelector(":scope > div:first-child"), S = M.querySelector(":scope > div:last-child");
      requestAnimationFrame(() => {
        E && (E.style.transition = "opacity 0.3s cubic-bezier(0.32, 0.72, 0, 1)", E.style.opacity = "1"), S && (S.style.transition = "transform 0.3s cubic-bezier(0.32, 0.72, 0, 1)", S.style.transform = "translateY(0)");
        const W = () => {
          S?.removeEventListener("transitionend", W), _();
        };
        S?.addEventListener("transitionend", W);
      });
    }, h = (T) => {
      const _ = T, M = _.querySelector(":scope > div:first-child"), E = _.querySelector(":scope > div:last-child");
      M && (M.style.transition = ""), E && (E.style.transition = "");
    }, O = (T, _) => {
      if (i.value) {
        i.value = !1, _();
        return;
      }
      const M = T, E = M.querySelector(":scope > div:first-child"), S = M.querySelector(":scope > div:last-child");
      E && (E.style.transition = "opacity 0.25s cubic-bezier(0.32, 0.72, 0, 1)", E.style.opacity = "0"), S && (S.style.transition = "transform 0.25s cubic-bezier(0.32, 0.72, 0, 1)", S.style.transform = "translateY(100%)");
      const W = () => {
        S?.removeEventListener("transitionend", W), _();
      };
      S?.addEventListener("transitionend", W);
    }, R = () => {
    }, F = (T) => {
      const _ = v.value;
      _ && (_.scrollTop > 0 || (s.value = !0, w.value = T.touches[0].clientY, r.value = 0, p.value = Date.now(), _.style.transition = "none", a.value && (a.value.style.transition = "none")));
    }, B = (T) => {
      if (!s.value) return;
      const _ = v.value;
      if (!_) return;
      const M = T.touches[0].clientY - w.value;
      if (M < 0) {
        r.value = 0, _.style.transform = "translateY(0)", a.value && (a.value.style.opacity = "1");
        return;
      }
      if (r.value = M, _.style.transform = `translateY(${M}px)`, a.value) {
        const E = _.offsetHeight, S = Math.min(M / E, 1);
        a.value.style.opacity = String(1 - S);
      }
    }, L = () => {
      if (!s.value) return;
      s.value = !1;
      const T = v.value;
      if (!T) return;
      const _ = T.offsetHeight, M = r.value / _, E = Date.now() - p.value, S = r.value / E * 1e3;
      M > Vl || S > Cl ? (T.style.transition = "transform 0.2s cubic-bezier(0.32, 0.72, 0, 1)", T.style.transform = "translateY(100%)", a.value && (a.value.style.transition = "opacity 0.2s cubic-bezier(0.32, 0.72, 0, 1)", a.value.style.opacity = "0"), T.addEventListener(
        "transitionend",
        () => {
          i.value = !0, f();
        },
        { once: !0 }
      )) : (T.style.transition = "transform 0.3s cubic-bezier(0.32, 0.72, 0, 1)", T.style.transform = "translateY(0)", a.value && (a.value.style.transition = "opacity 0.3s cubic-bezier(0.32, 0.72, 0, 1)", a.value.style.opacity = "1")), r.value = 0;
    };
    return re(
      () => e.modelValue,
      (T) => {
        document.body.style.overflow = T ? "hidden" : "";
      }
    ), (T, _) => (u(), J(je, { to: "body" }, [
      k(We, {
        onBeforeEnter: $,
        onEnter: V,
        onAfterEnter: h,
        onLeave: O,
        onAfterLeave: R
      }, {
        default: N(() => [
          t.modelValue ? (u(), g("div", {
            key: 0,
            ref_key: "rootRef",
            ref: o,
            class: "fixed inset-0 z-[9999]"
          }, [
            c("div", {
              ref_key: "backdropRef",
              ref: a,
              class: "absolute inset-0 bg-black/40",
              onClick: f
            }, null, 512),
            c("div", {
              ref_key: "sheetRef",
              ref: v,
              class: "absolute bottom-0 left-0 right-0 bg-white rounded-t-[16px] max-h-[85vh] flex flex-col overflow-hidden",
              onTouchstartPassive: F,
              onTouchmovePassive: B,
              onTouchendPassive: L
            }, [
              _[0] || (_[0] = c("div", { class: "flex justify-center pt-2.5 pb-1.5 cursor-grab" }, [
                c("div", { class: "w-[60px] h-1 bg-gray-800/20 rounded-xs" })
              ], -1)),
              ue(T.$slots, "default")
            ], 544)
          ], 512)) : H("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Be = 14, Je = /* @__PURE__ */ Symbol("TooltipContext"), Xe = (t) => {
  const l = Ge(Je, null);
  if (l === null)
    throw new Error(`<${t}> is missing parent <Tooltip /> component`);
  return l;
}, Ma = K({
  name: "Tooltip",
  props: {
    manual: {
      required: !1,
      default: !1
    },
    large: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: "top"
    }
  },
  setup(t, { slots: l }) {
    const e = {
      isActive: x(!1),
      openTooltip: () => {
        e.isActive.value = !0;
      },
      closeTooltip: () => {
        e.isActive.value = !1;
      },
      manual: t.manual !== !1,
      triggerRef: x(),
      large: t.large,
      position: t.position
    };
    return Ke(Je, e), () => ge("div", { class: "relative w-fit" }, l.default?.());
  }
}), Sa = K({
  name: "TooltipTrigger",
  setup(t, { slots: l }) {
    const e = Xe("TooltipTrigger");
    return () => ge(
      "div",
      {
        ...!e.manual && {
          onMouseover: e.openTooltip,
          onMouseleave: e.closeTooltip
        },
        ref: e.triggerRef
      },
      l.default?.()
    );
  }
}), Ra = K({
  name: "TooltipContent",
  setup(t, { slots: l }) {
    const e = Xe("TooltipContent"), n = x(), o = z(() => {
      if (!e.triggerRef.value || !n.value) return;
      const v = e.position === "top" ? `${e.triggerRef.value.getBoundingClientRect().top - n.value.clientHeight - Be}px` : `${e.triggerRef.value.getBoundingClientRect().bottom + Be + 2}px`, w = e.triggerRef.value.getBoundingClientRect().left - (n.value.clientWidth - e.triggerRef.value.clientWidth) / 2, r = `${w < 0 ? 14 : w}px`;
      return {
        top: v,
        left: r,
        leftValue: w
      };
    }), a = z(() => {
      if (o.value && o.value.leftValue < 0 && e.triggerRef.value) {
        const v = e.triggerRef.value.getBoundingClientRect();
        return {
          left: `${v.left - v.width}px`
        };
      }
      return {
        left: "50%",
        translate: "-50% 0"
      };
    });
    return () => ge(
      je,
      {
        to: "body"
      },
      ge(
        We,
        { name: "quick-fade-rise", appear: !0 },
        () => (e.manual || e.isActive.value) && ge(
          "div",
          {
            ref: n,
            class: `
                  w-fit
                  rounded-md
                  absolute
                  top-[-999px]
                  font-secondary
                  text-[14px]
                  leading-[20px]
                  text-white
                  bg-gray-700/95
                  z-999
                  pointer-events-none
                  ${e.large ? "px-4 py-[13px]" : "px-2.5 py-[7px]"}
                `,
            style: o.value
          },
          [
            ge("div", {
              class: `
                    border-l
                    border-l-[5px]
                    border-l-transparent
                    border-r
                    border-r-[5px]
                    border-r-transparent
                    border-t
                    border-t-[5px]
                    border-t-gray-700/95
                    absolute
                    z-[-1]
                    ${e.position === "top" ? "bottom-[-5px]" : "top-[-5px] rotate-180"}
                  `,
              style: a.value
            }),
            l.default?.()
          ]
        )
      )
    );
  }
}), za = {
  mounted: (t, { value: l, modifiers: e }) => {
    const n = () => {
      if (document.querySelector("#tooltip")) return;
      const a = document.createElement("div");
      a.id = "tooltip", a.classList.add(
        "w-fit",
        "rounded-md",
        "absolute",
        "top-[-999px]",
        "font-secondary",
        "text-[14px]",
        "leading-[20px]",
        "text-white",
        "bg-gray-700/95",
        "z-999",
        "pointer-events-none",
        "opacity-0",
        "translate-y-[15px]",
        "tooltip"
      ), e.large ? a.classList.add("px-4", "py-[13px]") : a.classList.add("px-2.5", "py-[7px]");
      const v = document.createElement("div");
      v.classList.add(
        "border-l",
        "border-l-[5px]",
        "border-l-transparent",
        "border-r",
        "border-r-[5px]",
        "border-r-transparent",
        "border-t",
        "border-t-[5px]",
        "border-t-gray-700/95",
        "absolute",
        "bottom-[-5px]",
        "z-[-1]"
      ), a.appendChild(v);
      const w = document.createElement("div");
      w.innerText = l, a.appendChild(w), document.body.appendChild(a), setTimeout(() => {
        a.style.top = `${t.getBoundingClientRect().top - a.clientHeight - Be}px`;
        const r = t.getBoundingClientRect().left - (a.clientWidth - t.clientWidth) / 2;
        a.style.left = `${r < 0 ? 14 : r}px`, r < 0 ? v.style.left = `${t.getBoundingClientRect().left - t.clientWidth}px` : (v.style.left = "50%", v.style.translate = "-50% 0"), a.style.opacity = "1", a.style.translate = "0";
      }, 25);
    }, o = () => {
      document.body.querySelector("#tooltip")?.remove();
    };
    t.addEventListener("mouseover", n), t.addEventListener("mouseleave", o);
  },
  unmounted: (t) => {
    document.body.querySelector("#tooltip")?.remove();
  }
}, Ml = { class: "flex flex-col min-w-[150px]" }, Sl = { class: "font-secondary text-[14px] leading-[18px] font-medium text-gray-800 px-1.5 py-[5px]" }, Rl = {
  key: 1,
  class: "p-1.5 w-full"
}, qe = /* @__PURE__ */ K({
  __name: "FilterPanel",
  props: {
    label: {},
    applyLabel: { default: "Apply" },
    compact: { type: Boolean, default: !1 }
  },
  emits: ["apply"],
  setup(t) {
    return (l, e) => (u(), J(_e, null, {
      default: N(() => [
        c("div", Ml, [
          t.compact ? H("", !0) : ue(l.$slots, "header", { key: 0 }, () => [
            c("div", Sl, " Filter by: " + P(t.label), 1)
          ]),
          ue(l.$slots, "default"),
          t.compact ? H("", !0) : (u(), g("div", Rl, [
            k(ye, {
              class: "w-full",
              variant: "primary",
              size: "md",
              onClick: e[0] || (e[0] = (n) => l.$emit("apply"))
            }, {
              default: N(() => [
                ie(P(t.applyLabel), 1)
              ]),
              _: 1
            })
          ]))
        ])
      ]),
      _: 3
    }));
  }
}), zl = { class: "flex flex-col" }, Fl = ["onClick"], Il = { class: "font-secondary text-[14px] text-gray-800" }, Tl = /* @__PURE__ */ K({
  __name: "FilterOption",
  props: {
    options: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = (a) => {
      n("update:modelValue", e.modelValue === a ? void 0 : a);
    };
    return (a, v) => (u(), g("div", zl, [
      (u(!0), g(te, null, oe(t.options, (w) => (u(), g("div", {
        key: w.value,
        class: "flex items-center justify-between gap-x-[10px] h-[34px] px-2.5 py-2 cursor-pointer select-none hover:bg-gray-200/25 rounded-md",
        onClick: (r) => o(w.value)
      }, [
        ue(a.$slots, "option", {
          option: w,
          selected: t.modelValue === w.value
        }, () => [
          c("span", Il, P(w.label), 1)
        ]),
        t.modelValue === w.value ? (u(), J(ee, {
          key: 0,
          name: "FilledCircleCheck",
          size: 16
        })) : H("", !0)
      ], 8, Fl))), 128))
    ]));
  }
}), El = { class: "flex flex-col" }, Ul = {
  key: 0,
  class: "p-1.5 pt-1"
}, Bl = { class: "flex flex-col max-h-[350px] overflow-y-auto" }, _l = ["onClick"], Ll = { class: "font-secondary text-[14px] text-gray-800" }, Pl = /* @__PURE__ */ K({
  __name: "FilterMultiSelect",
  props: {
    options: {},
    modelValue: { default: () => [] },
    searchable: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = x(""), a = z(() => {
      if (!o.value) return e.options;
      const i = o.value.toLowerCase();
      return e.options.filter(
        (f) => f.label.toLowerCase().includes(i)
      );
    }), v = z(
      () => a.value.length > 0 && a.value.every((i) => e.modelValue.includes(i.value))
    ), w = z(
      () => a.value.some((i) => e.modelValue.includes(i.value))
    ), r = (i) => e.modelValue.includes(i), s = (i) => {
      r(i) ? n(
        "update:modelValue",
        e.modelValue.filter((f) => f !== i)
      ) : n("update:modelValue", [...e.modelValue, i]);
    }, p = () => {
      if (v.value) {
        const i = new Set(a.value.map((f) => f.value));
        n(
          "update:modelValue",
          e.modelValue.filter((f) => !i.has(f))
        );
      } else {
        const i = new Set(e.modelValue), f = a.value.filter(($) => !i.has($.value)).map(($) => $.value);
        n("update:modelValue", [...e.modelValue, ...f]);
      }
    };
    return (i, f) => (u(), g("div", El, [
      t.searchable ? (u(), g("div", Ul, [
        k($e, {
          modelValue: o.value,
          "onUpdate:modelValue": f[0] || (f[0] = ($) => o.value = $),
          label: "Search",
          size: "md"
        }, null, 8, ["modelValue"])
      ])) : H("", !0),
      c("div", Bl, [
        c("div", {
          class: "flex items-center h-[34px] px-2.5 py-2 gap-2.5 cursor-pointer select-none hover:bg-gray-200/25 rounded-[10px]",
          onClick: p
        }, [
          k(Ye, {
            "model-value": v.value,
            indeterminate: w.value && !v.value,
            class: "pointer-events-none"
          }, null, 8, ["model-value", "indeterminate"]),
          f[1] || (f[1] = c("span", { class: "font-secondary text-[13px] leading-[18px] font-medium text-gray-600" }, "Select all", -1))
        ]),
        (u(!0), g(te, null, oe(a.value, ($) => (u(), g("div", {
          key: $.value,
          class: "flex items-center h-[34px] px-2.5 py-2 gap-2.5 cursor-pointer select-none hover:bg-gray-200/25 rounded-[10px]",
          onClick: (V) => s($.value)
        }, [
          k(Ye, {
            "model-value": r($.value),
            class: "pointer-events-none"
          }, null, 8, ["model-value"]),
          ue(i.$slots, "option", {
            option: $,
            selected: r($.value)
          }, () => [
            c("span", Ll, P($.label), 1)
          ])
        ], 8, _l))), 128))
      ])
    ]));
  }
}), Ze = [
  { value: "eq", label: "Is equal to" },
  { value: "between", label: "Is between" },
  { value: "gt", label: "Is greater than" },
  { value: "lt", label: "Is less than" }
], et = [
  { value: "eq", label: "Is equal to" },
  { value: "between", label: "Is between" },
  { value: "in_last", label: "Is in the last" },
  { value: "gte", label: "Is on or after" },
  { value: "lte", label: "Is before or on" }
], Yl = [
  { value: "hours", label: "hours" },
  { value: "days", label: "days" },
  { value: "months", label: "months" }
], Hl = { class: "flex flex-col gap-2.5 p-1.5" }, Ol = { class: "flex items-center gap-2 pl-1" }, Ql = /* @__PURE__ */ K({
  __name: "FilterNumber",
  props: {
    units: {},
    modelValue: { default: () => ({ operator: "eq", value: null }) }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = z(() => e.modelValue), a = z(
      () => Ze.map((p) => ({ value: p.value, label: p.label }))
    ), v = (p) => {
      n("update:modelValue", {
        ...o.value,
        operator: p
      });
    }, w = (p) => {
      const i = p === "" ? null : Number(p);
      n("update:modelValue", {
        ...o.value,
        value: i
      });
    }, r = (p) => {
      const i = p === "" ? null : Number(p);
      n("update:modelValue", {
        ...o.value,
        valueTo: i
      });
    }, s = (p) => {
      n("update:modelValue", {
        ...o.value,
        unit: p
      });
    };
    return (p, i) => (u(), g("div", Hl, [
      k(ze, {
        "model-value": o.value.operator,
        label: "Operator",
        options: a.value,
        size: "md",
        "onUpdate:modelValue": v
      }, null, 8, ["model-value", "options"]),
      c("div", Ol, [
        k(ee, {
          name: "SubsetArrow",
          size: 18,
          class: "shrink-0 stroke-gray-500"
        }),
        o.value.operator === "between" ? (u(), g(te, { key: 0 }, [
          k($e, {
            "model-value": o.value.value?.toString() ?? "",
            label: "Min",
            type: "number",
            size: "md",
            class: "min-w-0 flex-1",
            "onUpdate:modelValue": w
          }, null, 8, ["model-value"]),
          i[0] || (i[0] = c("span", { class: "font-secondary text-[13px] text-gray-500 shrink-0" }, "and", -1)),
          k($e, {
            "model-value": o.value.valueTo?.toString() ?? "",
            label: "Max",
            type: "number",
            size: "md",
            class: "min-w-0 flex-1",
            "onUpdate:modelValue": r
          }, null, 8, ["model-value"])
        ], 64)) : (u(), J($e, {
          key: 1,
          "model-value": o.value.value?.toString() ?? "",
          label: "Value",
          type: "number",
          size: "md",
          class: "min-w-0 flex-1",
          "onUpdate:modelValue": w
        }, null, 8, ["model-value"])),
        t.units && t.units.length > 0 ? (u(), J(ze, {
          key: 2,
          "model-value": o.value.unit ?? "",
          label: "Unit",
          options: t.units,
          size: "md",
          "onUpdate:modelValue": s
        }, null, 8, ["model-value", "options"])) : H("", !0)
      ])
    ]));
  }
}), ql = { class: "flex flex-col gap-2.5 p-1.5" }, Nl = {
  key: 0,
  class: "flex items-center gap-2 pl-1"
}, jl = { class: "flex items-center gap-2 pl-1" }, Wl = { class: "flex items-center gap-2" }, Kl = {
  key: 2,
  class: "flex items-center gap-2 pl-1"
}, Gl = /* @__PURE__ */ K({
  __name: "FilterDateTime",
  props: {
    modelValue: { default: () => ({
      operator: "eq",
      date: null,
      time: ""
    }) }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = z(() => e.modelValue), a = z(
      () => et.map((R) => ({ value: R.value, label: R.label }))
    ), v = z(
      () => Yl.map((R) => ({ value: R.value, label: R.label }))
    ), w = (R) => R ? R.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    }) : "Select date", r = z(() => w(o.value.date)), s = z(() => w(o.value.dateTo)), p = (R, F) => {
      R && !Array.isArray(R) && (F === "to" ? n("update:modelValue", { ...o.value, dateTo: R }) : n("update:modelValue", { ...o.value, date: R }));
    }, i = (R) => {
    }, f = (R) => {
      n("update:modelValue", {
        ...o.value,
        operator: R
      });
    }, $ = (R) => {
      n("update:modelValue", { ...o.value, time: R });
    }, V = (R) => {
      n("update:modelValue", { ...o.value, timeTo: R });
    }, h = (R) => {
      const F = R === "" ? null : Number(R);
      n("update:modelValue", { ...o.value, lastValue: F });
    }, O = (R) => {
      n("update:modelValue", {
        ...o.value,
        lastUnit: R
      });
    };
    return (R, F) => (u(), g("div", ql, [
      k(ze, {
        "model-value": o.value.operator,
        label: "Operator",
        options: a.value,
        size: "md",
        "onUpdate:modelValue": f
      }, null, 8, ["model-value", "options"]),
      o.value.operator === "in_last" ? (u(), g("div", Nl, [
        k(ee, {
          name: "SubsetArrow",
          size: 18,
          class: "shrink-0 stroke-gray-500"
        }),
        k($e, {
          "model-value": o.value.lastValue?.toString() ?? "",
          label: "Value",
          type: "number",
          size: "md",
          class: "min-w-0 flex-1",
          "onUpdate:modelValue": h
        }, null, 8, ["model-value"]),
        k(ze, {
          "model-value": o.value.lastUnit ?? "days",
          label: "Unit",
          options: v.value,
          size: "md",
          "onUpdate:modelValue": O
        }, null, 8, ["model-value", "options"])
      ])) : o.value.operator === "between" ? (u(), g(te, { key: 1 }, [
        c("div", jl, [
          k(ee, {
            name: "SubsetArrow",
            size: 18,
            class: "shrink-0 stroke-gray-500"
          }),
          k(Z(we), {
            anchor: "left",
            onClose: F[1] || (F[1] = (B) => i())
          }, {
            default: N(() => [
              k(Z(Ve), null, {
                default: N(() => [
                  k(ye, {
                    variant: "stroke",
                    size: "md",
                    class: "w-full"
                  }, {
                    default: N(() => [
                      ie(P(r.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              k(Z(Ce), null, {
                default: N(() => [
                  k(Re, {
                    "model-value": o.value.date,
                    mode: "single",
                    view: "single",
                    "onUpdate:modelValue": F[0] || (F[0] = (B) => p(B, "from"))
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          F[6] || (F[6] = c("span", { class: "font-secondary text-[13px] text-gray-500 shrink-0" }, "at", -1)),
          k(Ee, {
            "model-value": o.value.time,
            label: "Time",
            "onUpdate:modelValue": $
          }, null, 8, ["model-value"])
        ]),
        c("div", Wl, [
          F[7] || (F[7] = c("span", { class: "font-secondary text-[13px] leading-[18px] font-medium text-gray-600" }, "and", -1)),
          k(Z(we), {
            anchor: "left",
            onClose: F[3] || (F[3] = (B) => i())
          }, {
            default: N(() => [
              k(Z(Ve), null, {
                default: N(() => [
                  k(ye, {
                    variant: "stroke",
                    size: "md",
                    class: "w-full"
                  }, {
                    default: N(() => [
                      ie(P(s.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              k(Z(Ce), null, {
                default: N(() => [
                  k(Re, {
                    "model-value": o.value.dateTo ?? null,
                    mode: "single",
                    view: "single",
                    "onUpdate:modelValue": F[2] || (F[2] = (B) => p(B, "to"))
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          F[8] || (F[8] = c("span", { class: "font-secondary text-[13px] text-gray-500 shrink-0" }, "at", -1)),
          k(Ee, {
            "model-value": o.value.timeTo ?? "",
            label: "Time",
            "onUpdate:modelValue": V
          }, null, 8, ["model-value"])
        ])
      ], 64)) : (u(), g("div", Kl, [
        k(ee, {
          name: "SubsetArrow",
          size: 18,
          class: "shrink-0 stroke-gray-500"
        }),
        k(Z(we), {
          anchor: "left",
          onClose: F[5] || (F[5] = (B) => i())
        }, {
          default: N(() => [
            k(Z(Ve), null, {
              default: N(() => [
                k(ye, {
                  variant: "stroke",
                  size: "md",
                  class: "w-full"
                }, {
                  default: N(() => [
                    ie(P(r.value), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            k(Z(Ce), null, {
              default: N(() => [
                k(Re, {
                  "model-value": o.value.date,
                  mode: "single",
                  view: "single",
                  "onUpdate:modelValue": F[4] || (F[4] = (B) => p(B, "from"))
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        F[9] || (F[9] = c("span", { class: "font-secondary text-[13px] text-gray-500 shrink-0" }, "at", -1)),
        k(Ee, {
          "model-value": o.value.time,
          label: "Time",
          "onUpdate:modelValue": $
        }, null, 8, ["model-value"])
      ]))
    ]));
  }
}), Jl = { class: "flex flex-col pb-10" }, Xl = {
  key: 0,
  id: "presets",
  class: "flex overflow-x-auto px-5 py-2 gap-x-1.5"
}, Zl = ["onClick"], ea = {
  key: 1,
  class: "flex items-center justify-center gap-2 px-5 py-2"
}, ta = { class: "w-[180px]" }, la = { class: "w-[180px]" }, aa = {
  key: 2,
  class: "px-1.5 py-[5px]"
}, na = { class: "flex justify-center py-2" }, sa = /* @__PURE__ */ K({
  __name: "MobileDatePicker",
  props: {
    modelValue: {},
    mode: { default: "single" },
    presets: { type: Boolean }
  },
  emits: ["update:modelValue", "presetSelect"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = /* @__PURE__ */ new Date(), a = x(o.getFullYear()), v = x(o.getMonth() + 1), w = x("day"), r = x(null), s = x([null, null]), p = x(!0), i = x(null), f = x(null), $ = x(""), V = x(""), h = x(""), O = (A) => {
      e.mode === "range" && !p.value && s.value[0] && !s.value[1] && (f.value = A);
    }, R = () => {
      if (e.mode === "single" && e.modelValue && !Array.isArray(e.modelValue) && (r.value = e.modelValue, $.value = ne(r.value), a.value = r.value.getFullYear(), v.value = r.value.getMonth() + 1), e.mode === "range" && e.modelValue && Array.isArray(e.modelValue)) {
        s.value = [...e.modelValue], V.value = ne(s.value[0]), h.value = ne(s.value[1]);
        const A = s.value[1] || s.value[0];
        A && (a.value = A.getFullYear(), v.value = A.getMonth() + 1);
      }
    }, F = (A) => {
      a.value = A.getFullYear(), v.value = A.getMonth() + 1;
    }, B = (A) => {
      $.value = A;
      const C = xe(A);
      C && (r.value = C, F(C), n("update:modelValue", C));
    }, L = (A) => {
      V.value = A, i.value = null;
      const C = xe(A);
      C && (s.value = [C, s.value[1]], F(C), _());
    }, T = (A) => {
      h.value = A, i.value = null;
      const C = xe(A);
      if (C) {
        const I = new Date(C);
        I.setHours(23, 59, 59, 999), s.value = [s.value[0], I], F(C), _();
      }
    }, _ = () => {
      const [A, C] = s.value;
      if (A && C) {
        const I = i.value?.label ?? W()?.label ?? null;
        n("presetSelect", I), n("update:modelValue", [...s.value]);
      }
    }, M = (A) => {
      if (e.mode === "single") {
        r.value = A, $.value = ne(A), n("update:modelValue", A);
        return;
      }
      i.value = null;
      const [C] = s.value;
      if (p.value || !C)
        s.value = [A, null], V.value = ne(A), h.value = "", p.value = !1;
      else {
        if (A >= C) {
          const I = new Date(A);
          I.setHours(23, 59, 59, 999), s.value = [C, I], h.value = ne(I);
        } else {
          s.value = [A, null], V.value = ne(A), h.value = "", p.value = !1;
          return;
        }
        p.value = !0, f.value = null, _();
      }
    }, E = (A) => {
      i.value = A;
      const C = A.getValue();
      s.value = [...C], V.value = ne(C[0]), h.value = ne(C[1]), p.value = !0;
      const I = C[1] || C[0];
      I && (a.value = I.getFullYear(), v.value = I.getMonth() + 1), n("presetSelect", A.label), n("update:modelValue", [...C]);
    }, S = (A, C) => !A || !C ? A === C : A.getFullYear() === C.getFullYear() && A.getMonth() === C.getMonth() && A.getDate() === C.getDate(), W = () => {
      if (!e.presets) return null;
      const [A, C] = s.value;
      if (!A || !C) return null;
      for (const I of Fe) {
        const [le, se] = I.getValue();
        if (le && se && S(A, le) && S(C, se))
          return I;
      }
      return null;
    };
    return re(
      () => e.modelValue,
      () => R(),
      { immediate: !0 }
    ), (A, C) => (u(), g("div", Jl, [
      t.presets ? (u(), g("div", Xl, [
        (u(!0), g(te, null, oe(Z(Et), (I) => (u(), g("button", {
          key: I.id,
          class: j(["h-[30px] w-[43px] rounded-[6px] text-[13px] font-medium font-secondary select-none", i.value?.id === I.id ? "bg-green-700 text-white" : "text-gray-600"]),
          onClick: (le) => E(I)
        }, P(I.shortLabel), 11, Zl))), 128))
      ])) : H("", !0),
      t.mode === "range" ? (u(), g("div", ea, [
        c("div", ta, [
          k(he, {
            label: "Start date",
            "model-value": V.value,
            "onUpdate:modelValue": L
          }, null, 8, ["model-value"])
        ]),
        C[3] || (C[3] = c("span", { class: "text-[14px] text-gray-500 font-secondary" }, "—", -1)),
        c("div", la, [
          k(he, {
            label: "End date",
            "model-value": h.value,
            "onUpdate:modelValue": T
          }, null, 8, ["model-value"])
        ])
      ])) : (u(), g("div", aa, [
        k(he, {
          label: "Date",
          "model-value": $.value,
          "onUpdate:modelValue": B
        }, null, 8, ["model-value"])
      ])),
      C[4] || (C[4] = c("div", { class: "w-full h-px bg-gray-200 my-3" }, null, -1)),
      c("div", na, [
        k(Ue, {
          year: a.value,
          month: v.value,
          "selection-mode": w.value,
          "selected-date": t.mode === "single" ? r.value : void 0,
          "selected-range": t.mode === "range" ? s.value : void 0,
          "hover-date": f.value,
          "show-prev-arrow": !0,
          "show-next-arrow": !0,
          "onUpdate:year": C[0] || (C[0] = (I) => a.value = I),
          "onUpdate:month": C[1] || (C[1] = (I) => v.value = I),
          "onUpdate:selectionMode": C[2] || (C[2] = (I) => w.value = I),
          onDateClick: M,
          onDateHover: O
        }, null, 8, ["year", "month", "selection-mode", "selected-date", "selected-range", "hover-date"])
      ])
    ]));
  }
}), oa = /* @__PURE__ */ pe(sa, [["__scopeId", "data-v-aa507e62"]]);
function ra() {
  const t = x(!1);
  if (typeof window < "u") {
    const l = window.matchMedia("(max-width: 767px)");
    t.value = l.matches;
    const e = (n) => {
      t.value = n.matches;
    };
    l.addEventListener("change", e), ot(() => l.removeEventListener("change", e));
  }
  return { isMobile: t };
}
const tt = /* @__PURE__ */ Symbol("FiltersContext"), ua = (t) => {
  Ke(tt, t);
}, lt = (t) => {
  const l = Ge(tt, null);
  if (l === null)
    throw new Error(`<${t}> is missing parent <Filters /> component`);
  return l;
}, be = (t) => t ? t.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "...", ia = (t, l) => {
  const e = t;
  return e ? l.options?.find((o) => o.value === e)?.label ?? e : "Select...";
}, da = (t, l) => {
  const e = t;
  return !e || e.length === 0 ? "Select..." : e.length === 1 ? l.multiSelectOptions?.find((o) => o.value === e[0])?.label ?? e[0] : `${e.length} selected`;
}, ca = (t, l) => {
  const e = t, n = e.unit ? l.units?.find((v) => v.value === e.unit)?.label ?? e.unit : "", o = n ? ` ${n}` : "", a = Ze.find((v) => v.value === e.operator);
  return e.operator === "between" ? `${e.value ?? "..."}${o} - ${e.valueTo ?? "..."}${o}` : `${a?.label ?? e.operator} ${e.value ?? "..."}${o}`;
}, pa = (t) => {
  const l = t;
  return l.presetLabel ? l.presetLabel : l.dateTo ? `${be(l.date)} - ${be(l.dateTo)}` : be(l.date);
}, va = (t) => {
  const l = t, e = et.find((n) => n.value === l.operator);
  return l.operator === "in_last" ? `Last ${l.lastValue ?? "..."} ${l.lastUnit ?? "days"}` : l.operator === "between" ? `${be(l.date)} - ${be(l.dateTo)}` : `${e?.label ?? l.operator} ${be(l.date)}`;
}, fa = (t, l) => {
  if (l.formatValue)
    return l.formatValue(t, l);
  switch (l.type) {
    case "select":
      return ia(t, l);
    case "multi-select":
      return da(t, l);
    case "number":
      return ca(t, l);
    case "date":
      return pa(t);
    case "datetime":
      return va(t);
  }
}, ma = (t) => {
  if (t.defaultValue !== void 0) return t.defaultValue;
  switch (t.type) {
    case "select":
      return t.options?.[0]?.value ?? "";
    case "multi-select":
      return [];
    case "number":
      return { operator: "eq", value: null, unit: t.units?.[0]?.value };
    case "date":
      return { date: null };
    case "datetime":
      return { operator: "eq", date: null, time: "" };
  }
}, ga = { class: "text-gray-600" }, ya = { class: "text-green-700 font-medium" }, xa = { class: "text-gray-600" }, ha = { class: "text-green-700 font-medium" }, ba = /* @__PURE__ */ K({
  __name: "FilterPill",
  props: {
    filter: {}
  },
  setup(t) {
    const l = t, e = lt("FilterPill"), n = x(null), o = x(!1), a = x(null), { isMobile: v } = ra(), w = x(!1), r = z(() => e.getDefinition(l.filter.id)), s = z(() => v.value && r.value?.type === "date"), p = z(() => r.value ? fa(l.filter.value, r.value) : ""), i = x(structuredClone(Te(l.filter.value)));
    re(
      () => l.filter.value,
      (B) => {
        i.value = structuredClone(Te(B));
      }
    );
    const f = () => {
      o.value = !1, e.updateFilter(l.filter.id, i.value), document.body.click();
    }, $ = () => {
      if (o.value) {
        e.removeFilter(l.filter.id);
        return;
      }
      i.value = structuredClone(Te(l.filter.value));
    }, V = () => {
      e.removeFilter(l.filter.id);
    }, h = (B) => {
      B !== void 0 && (o.value = !1, e.updateFilter(l.filter.id, B), document.body.click());
    }, O = z(() => {
      const B = i.value;
      return r.value?.datePickerMode === "range" ? [B.date, B.dateTo ?? null] : B.date;
    }), R = (B) => {
      if (Array.isArray(B)) {
        o.value = !1;
        const L = { date: B[0], dateTo: B[1] };
        a.value && (L.presetLabel = a.value), e.updateFilter(l.filter.id, L), a.value = null, document.body.click();
      } else B && (o.value = !1, e.updateFilter(l.filter.id, { date: B }), a.value = null, document.body.click());
    }, F = (B) => {
      if (Array.isArray(B)) {
        o.value = !1;
        const L = { date: B[0], dateTo: B[1] };
        a.value && (L.presetLabel = a.value), e.updateFilter(l.filter.id, L), a.value = null, w.value = !1;
      } else B && (o.value = !1, e.updateFilter(l.filter.id, { date: B }), a.value = null, w.value = !1);
    };
    return Ne(() => {
      e.autoOpenId.value === l.filter.id && (e.autoOpenId.value = null, o.value = !0, s.value ? w.value = !0 : ce(() => {
        n.value?.click();
      }));
    }), (B, L) => s.value ? (u(), g(te, { key: 0 }, [
      c("button", {
        ref_key: "triggerEl",
        ref: n,
        class: "inline-flex items-center gap-1.5 h-6 px-[7px] py-px border border-gray-200 rounded-[20px] cursor-pointer select-none font-secondary font-medium text-[12px] leading-[15px]",
        onClick: L[0] || (L[0] = (T) => w.value = !0)
      }, [
        r.value?.hideRemove ? H("", !0) : (u(), J(ee, {
          key: 0,
          name: "Plus",
          size: 10,
          class: "stroke-gray-600/50 rotate-45",
          onClick: de(V, ["stop"])
        })),
        r.value?.hideLabel ? H("", !0) : (u(), g(te, { key: 1 }, [
          c("span", ga, P(r.value?.label), 1),
          L[7] || (L[7] = c("span", { class: "text-gray-300" }, "|", -1))
        ], 64)),
        c("span", ya, P(p.value), 1),
        k(ee, {
          name: "ChevronUp",
          size: 10,
          class: "stroke-[#5a616b] shrink-0 rotate-180"
        })
      ], 512),
      k($l, {
        modelValue: w.value,
        "onUpdate:modelValue": L[2] || (L[2] = (T) => w.value = T)
      }, {
        default: N(() => [
          k(oa, {
            "model-value": O.value,
            mode: r.value.datePickerMode ?? "single",
            presets: r.value.datePickerPresets,
            "onUpdate:modelValue": F,
            onPresetSelect: L[1] || (L[1] = (T) => a.value = T)
          }, null, 8, ["model-value", "mode", "presets"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 64)) : (u(), J(Z(we), {
      key: 1,
      anchor: r.value?.floatAnchor ?? "right",
      onClose: $
    }, {
      default: N(() => [
        k(Z(Ve), null, {
          default: N(() => [
            c("button", {
              ref_key: "triggerEl",
              ref: n,
              class: "inline-flex items-center gap-1.5 h-6 px-[7px] py-px border border-gray-200 rounded-[20px] cursor-pointer select-none font-secondary font-medium text-[12px] leading-[15px]"
            }, [
              r.value?.hideRemove ? H("", !0) : (u(), J(ee, {
                key: 0,
                name: "Plus",
                size: 10,
                class: "stroke-gray-600/50 rotate-45",
                onClick: de(V, ["stop"])
              })),
              r.value?.hideLabel ? H("", !0) : (u(), g(te, { key: 1 }, [
                c("span", xa, P(r.value?.label), 1),
                L[8] || (L[8] = c("span", { class: "text-gray-300" }, "|", -1))
              ], 64)),
              c("span", ha, P(p.value), 1),
              k(ee, {
                name: "ChevronUp",
                size: 10,
                class: "stroke-[#5a616b] shrink-0 rotate-180"
              })
            ], 512)
          ]),
          _: 1
        }),
        k(Z(Ce), null, {
          default: N(() => [
            r.value?.type === "select" ? (u(), J(qe, {
              key: 0,
              label: r.value.label,
              compact: ""
            }, {
              default: N(() => [
                k(Tl, {
                  options: r.value.options ?? [],
                  "model-value": i.value,
                  "onUpdate:modelValue": h
                }, null, 8, ["options", "model-value"])
              ]),
              _: 1
            }, 8, ["label"])) : r.value?.type === "date" ? (u(), J(Re, {
              key: 1,
              "model-value": O.value,
              mode: r.value.datePickerMode ?? "single",
              view: r.value.datePickerView ?? "single",
              presets: r.value.datePickerPresets,
              "onUpdate:modelValue": R,
              onPresetSelect: L[3] || (L[3] = (T) => a.value = T)
            }, null, 8, ["model-value", "mode", "view", "presets"])) : r.value ? (u(), J(qe, {
              key: 2,
              label: r.value.label,
              onApply: f
            }, {
              default: N(() => [
                r.value.type === "multi-select" ? (u(), J(Pl, {
                  key: 0,
                  options: r.value.multiSelectOptions ?? [],
                  searchable: r.value.searchable ?? !1,
                  "model-value": i.value,
                  "onUpdate:modelValue": L[4] || (L[4] = (T) => i.value = T)
                }, null, 8, ["options", "searchable", "model-value"])) : r.value.type === "number" ? (u(), J(Ql, {
                  key: 1,
                  units: r.value.units,
                  "model-value": i.value,
                  "onUpdate:modelValue": L[5] || (L[5] = (T) => i.value = T)
                }, null, 8, ["units", "model-value"])) : r.value.type === "datetime" ? (u(), J(Gl, {
                  key: 2,
                  "model-value": i.value,
                  "onUpdate:modelValue": L[6] || (L[6] = (T) => i.value = T)
                }, null, 8, ["model-value"])) : H("", !0)
              ]),
              _: 1
            }, 8, ["label"])) : H("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["anchor"]));
  }
}), Aa = { class: "inline-flex items-center gap-[5px] h-6 px-[7px] py-px border border-dashed border-gray-200 rounded-[20px] cursor-pointer select-none font-secondary text-[12px] text-gray-600 font-medium" }, Da = /* @__PURE__ */ K({
  __name: "FiltersAdd",
  setup(t) {
    const l = lt("FiltersAdd"), e = (n) => {
      document.body.click(), l.addFilter(n);
    };
    return (n, o) => (u(), J(Z(we), { anchor: "left" }, {
      default: N(() => [
        k(Z(Ve), null, {
          default: N(() => [
            c("button", Aa, [
              k(ee, {
                name: "Plus",
                size: 10,
                class: "stroke-gray-600"
              }),
              o[0] || (o[0] = c("span", null, "Add filter", -1))
            ])
          ]),
          _: 1
        }),
        k(Z(Ce), null, {
          default: N(() => [
            k(hl, null, {
              default: N(() => [
                (u(!0), g(te, null, oe(Z(l).availableDefinitions.value, (a) => (u(), J(bl, {
                  key: a.id,
                  onClick: (v) => e(a.id)
                }, {
                  default: N(() => [
                    ie(P(a.label), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), ka = { class: "flex items-center gap-2 flex-wrap" }, Fa = /* @__PURE__ */ K({
  __name: "Filters",
  props: {
    definitions: {},
    modelValue: {},
    hideAdd: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: l }) {
    const e = t, n = l, o = Pe(e, "modelValue"), a = Pe(e, "definitions"), v = z(() => {
      const $ = new Set(e.modelValue.map((V) => V.id));
      return e.definitions.filter((V) => !$.has(V.id));
    }), w = x(null), r = ($) => e.definitions.find((V) => V.id === $);
    return ua({
      definitions: a,
      appliedFilters: o,
      availableDefinitions: v,
      autoOpenId: w,
      getDefinition: r,
      updateFilter: ($, V) => {
        n(
          "update:modelValue",
          e.modelValue.map((h) => h.id === $ ? { ...h, value: V } : h)
        );
      },
      removeFilter: ($) => {
        n(
          "update:modelValue",
          e.modelValue.filter((V) => V.id !== $)
        );
      },
      addFilter: ($) => {
        const V = r($);
        V && (w.value = $, n("update:modelValue", [
          ...e.modelValue,
          { id: $, value: ma(V) }
        ]));
      }
    }), ($, V) => (u(), g("div", ka, [
      (u(!0), g(te, null, oe(t.modelValue, (h) => (u(), J(ba, {
        key: h.id,
        filter: h
      }, null, 8, ["filter"]))), 128)),
      !t.hideAdd && v.value.length > 0 ? (u(), J(Da, { key: 0 })) : H("", !0)
    ]));
  }
});
export {
  $l as BottomSheet,
  ye as Button,
  _e as Container,
  Re as DatePicker,
  Fa as Filters,
  $e as Input,
  Ca as Label,
  hl as Menu,
  bl as MenuItem,
  $a as PillTabs,
  ze as Select,
  Ee as TimeInput,
  Ma as Tooltip,
  Ra as TooltipContent,
  za as TooltipDirective,
  Sa as TooltipTrigger
};
